import { useState, useEffect, useRef, useMemo } from "react";
import './App.css';
import { auth, db, storage, functions } from './firebase';
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';
import { collection, doc, getDoc, getDocs, addDoc, updateDoc, deleteDoc, onSnapshot, query, where, orderBy } from 'firebase/firestore';
import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { httpsCallable } from 'firebase/functions';

// Vidvana Sphere logo (optimized WebP, 97x80px)
const LOGO_B64 = "data:image/webp;base64,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";

// ─── SEED DATA (DEPRECATED) ───────────────────────────────────────────────────
// DEPRECATED: Now loaded from Firestore via onSnapshot in root App component.
// Kept here for rollback reference only — not used by any component.
// const DEMO_TOKEN = { coordinator: "demo_coord", teacher: "demo_teacher", student: "demo_student" };
// const STUDENTS = [
//   { id:"s1", name:"Arjun Mehta",  role:"student", initials:"AM", grade:"Class 10", location:"New York, USA",    tz:"America/New_York", tzL:"ET",  phone:"+1-212-555-0191", email:"arjun@vidvana.in",   teachers:["t1","t2"], pass:DEMO_TOKEN.student },
//   { id:"s2", name:"Priya Kapoor", role:"student", initials:"PK", grade:"Class 9",  location:"Toronto, Canada", tz:"America/Toronto",   tzL:"ET",  phone:"+1-416-555-0182", email:"priya.k@vidvana.in", teachers:["t1"],       pass:DEMO_TOKEN.student },
//   { id:"s3", name:"Rahul Singh",  role:"student", initials:"RS", grade:"Class 11", location:"London, UK",      tz:"Europe/London",     tzL:"GMT", phone:"+44-20-5550-0193",email:"rahul@vidvana.in",   teachers:["t2"],       pass:DEMO_TOKEN.student },
// ];
// const TEACHERS = [
//   { id:"t1", name:"Ms. Priya Sharma", role:"teacher", initials:"PS", subject:"Mathematics", location:"Mumbai, India",    tz:"Asia/Kolkata", tzL:"IST", phone:"+91-98765-43210", email:"priya.s@vidvana.in", students:["s1","s2"], pass:DEMO_TOKEN.teacher },
//   { id:"t2", name:"Mr. Ravi Nair",    role:"teacher", initials:"RN", subject:"Physics",     location:"Bengaluru, India", tz:"Asia/Kolkata", tzL:"IST", phone:"+91-87654-32109", email:"ravi@vidvana.in",    students:["s1","s3"], pass:DEMO_TOKEN.teacher },
// ];
// const COORD = { id:"coord", name:"Ms. Anjali Mehra", role:"coordinator", initials:"AJ", email:"coord@vidvana.in", phone:"+91-90000-11111", pass:DEMO_TOKEN.coordinator };

// ─── UTILS ────────────────────────────────────────────────────────────────────
const normalizeDoc = data => Object.fromEntries(Object.entries(data).map(([k,v]) => [k.trim(), v]));
const pad = n => String(n).padStart(2,"0");
const toDS = d => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
const addM = (d,m) => new Date(d.getTime()+m*60000);
const addD = (d,n) => new Date(d.getTime()+n*86400000);
const nowTZ = tz => { try { return new Date().toLocaleTimeString("en-US",{timeZone:tz,hour:"2-digit",minute:"2-digit",hour12:true}); } catch { return ""; } };
function getTimezoneOffset(tz, date) {
  const utcStr = date.toLocaleString("en-US", { timeZone: "UTC" });
  const tzStr  = date.toLocaleString("en-US", { timeZone: tz });
  return (new Date(utcStr) - new Date(tzStr)) / 60000;
}
function formatTime12(time) {
  if (!time) return "";
  const [h, m] = time.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  return (h % 12 || 12) + ":" + String(m).padStart(2, "0") + " " + ampm;
}
function convertTZ(time, date, fromTZ, toTZ) {
  if (!time || !date || !fromTZ || !toTZ) return null;
  if (fromTZ === toTZ) return { time: formatTime12(time), date: null, isDifferentDay: false };
  try {
    const refDate    = new Date(date + "T12:00:00Z");
    const fromOffset = getTimezoneOffset(fromTZ, refDate);
    const utcMs      = new Date(date + "T" + time + ":00Z").getTime() + fromOffset * 60000;
    const utcDate    = new Date(utcMs);
    const fmt = opts => new Intl.DateTimeFormat("en-US", { timeZone: toTZ, ...opts }).format(utcDate);
    const convertedTime    = fmt({ hour: "2-digit", minute: "2-digit", hour12: true });
    const convertedDateStr = fmt({ month: "short", day: "numeric" });
    const originalDateStr  = new Intl.DateTimeFormat("en-US", { timeZone: fromTZ, month: "short", day: "numeric" }).format(utcDate);
    return { time: convertedTime, date: convertedDateStr, isDifferentDay: convertedDateStr !== originalDateStr };
  } catch (e) { return null; }
}
function TimeDisplay({ c, user, allUsers }) {
  const scheduledTZ  = c.scheduledTZ  || "Asia/Kolkata";
  const scheduledTZL = c.scheduledTZL || "IST";
  const viewerTZ     = user?.tz  || "Asia/Kolkata";
  const viewerTZL    = user?.tzL || "IST";

  const student = allUsers?.students?.find(s => c.sIds?.includes(s.id));
  const studentTZ = student?.tz;
  const studentTZL = student?.tzL;

  const vConv = convertTZ(c.time, c.date, scheduledTZ, viewerTZ) || { time: formatTime12(c.time), isDifferentDay: false };
  const vTimeStr = `${vConv.time} (${viewerTZL})`;

  if (user?.role === "student") {
    return <span>{vTimeStr}{vConv.isDifferentDay ? " · " + vConv.date : ""}</span>;
  }

  if (studentTZ && studentTZ !== viewerTZ) {
    const sConv = convertTZ(c.time, c.date, scheduledTZ, studentTZ);
    if (sConv) {
      return (
        <span>
          {vTimeStr}
          <span style={{ color:"var(--t3)", fontSize:11 }}> · {sConv.time} ({studentTZL})</span>
          {vConv.isDifferentDay ? <span style={{ color:"var(--wa)", fontSize:10 }}> +1d</span> : ""}
        </span>
      );
    }
  }

  return <span>{vTimeStr}{vConv.isDifferentDay ? <span style={{ color:"var(--wa)", fontSize:10 }}> +1d</span> : ""}</span>;
}
const fmtDate = ds => { const d=new Date(ds+"T00:00:00"),t=new Date();t.setHours(0,0,0,0);const diff=Math.round((d-t)/86400000);if(diff===0)return"Today";if(diff===1)return"Tomorrow";if(diff===-1)return"Yesterday";return d.toLocaleDateString("en-IN",{weekday:"short",month:"short",day:"numeric"}); };

function linkActive(cls, user) {
  if (cls.done) return false;
  return fmtDate(cls.date) === "Today";
}
function clsStatus(cls) {
  if(cls.done) return "done";
  const dt=new Date(`${cls.date}T${cls.time}`),n=new Date();
  if(n<addM(dt,-15)) return "sched";
  if(n>=addM(dt,-15)&&n<dt) return "soon";
  if(n>=dt&&n<=addM(dt,cls.dur)) return "live";
  return "mark";
}

// DEPRECATED: Classes now loaded from Firestore "classes" collection via onSnapshot.
// const N = new Date();
// const INIT_CLS = [ ... ];
// DEPRECATED: Files now stored in Firestore "files" collection via onSnapshot.
// const INIT_FILES = [ ... ];
// DEPRECATED: Chat messages now stored in Firestore "messages" collection.
// const initChat = () => ({ ... });

// DEPRECATED: Tickets now stored in Firestore "tickets" collection.
// const INIT_TICKETS = [ ... ];


// CSS is now in App.css (imported at top)

// ─── ICONS ────────────────────────────────────────────────────────────────────
const SVG = (d,s=16) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{d}</svg>;
const IC = {
  home:    SVG(<><rect x="3" y="9" width="18" height="13" rx="2"/><polyline points="3,9 12,3 21,9"/></>),
  cal:     SVG(<><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>),
  chat:    SVG(<><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></>),
  file:    SVG(<><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="13,2 13,9 20,9"/></>),
  people:  SVG(<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>),
  att:     SVG(<><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></>),
  help:    SVG(<><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></>),
  guide:   SVG(<><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></>),
  meet:    SVG(<><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></>),
  out:     SVG(<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></>),
  plus:    SVG(<><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>),
  send:    SVG(<><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></>),
  edit:    SVG(<><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></>),
  clock:   SVG(<><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>),
  loc:     SVG(<><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></>),
  mail:    SVG(<><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></>),
  phone:   SVG(<><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.93a16 16 0 0 0 6.06 6.06l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.01z"/></>),
  globe:   SVG(<><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></>),
  check:   SVG(<><polyline points="20,6 9,17 4,12"/></>),
  trash:   SVG(<><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></>),
  reply:   SVG(<><polyline points="9 17 4 12 9 7"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/></>),
  rep:     SVG(<><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></>),
  sun:     SVG(<><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></>),
  moon:    SVG(<><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></>),
  up:      SVG(<><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></>),
  info:    SVG(<><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></>),
  chev:    SVG(<><polyline points="6 9 12 15 18 9"/></>),
  eye:     SVG(<><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>),
  eye_off: SVG(<><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></>),
};

// ─── THEME TOGGLE ─────────────────────────────────────────────────────────────
function ThemeToggle({ dk, toggle, mini }) {
  if (mini) return (
    <div style={{ display:"flex",alignItems:"center",gap:6,fontSize:11,color:"var(--t3)" }}>
      {IC.sun}
      <div className={`trk ${dk?"dk":"lt"}`} onClick={toggle} style={{ cursor:"pointer" }}>
        <div className={`knob ${dk?"dk":"lt"}`} />
      </div>
      {IC.moon}
    </div>
  );
  return (
    <div className="tm-wrap" onClick={toggle}>
      <span style={{ color:"var(--t3)" }}>{dk ? IC.moon : IC.sun}</span>
      <span className="tm-lbl">{dk ? "Dark mode" : "Light mode"}</span>
      <div className={`trk ${dk?"dk":"lt"}`}><div className={`knob ${dk?"dk":"lt"}`} /></div>
    </div>
  );
}

// ─── LOGIN ────────────────────────────────────────────────────────────────────
function LoginPage({ onLogin, dk, toggle }) {
  const [email, setEmail] = useState(""); const [pass, setPass] = useState(""); const [err, setErr] = useState(""); const [showPass, setShowPass] = useState(false);
  const doLogin = async () => {
    setErr("");
    try {
      const cred = await signInWithEmailAndPassword(auth, email, pass);
      const userDoc = await getDoc(doc(db, "users", cred.user.uid));
      if (userDoc.exists()) {
        const userData = { id: cred.user.uid, ...normalizeDoc(userDoc.data()) };
        onLogin(userData);
      } else {
        setErr("Account exists but profile not found. Contact admin.");
      }
    } catch (err) {
      if (err.code === 'auth/invalid-credential' || err.code === 'auth/wrong-password' || err.code === 'auth/user-not-found') {
        setErr("Invalid email or password.");
      } else {
        setErr("Login failed: " + err.message);
      }
    }
  };
  return (
    <div className="login">
      <div className="login-bg1" /><div className="login-bg2" /><div className="login-bg3" />
      <div className="login-card">
        <div className="login-hd">
          <div className="login-logo">
            <img src={LOGO_B64} alt="Vidvana" style={{width:72,height:60,objectFit:"contain",filter:"drop-shadow(0 4px 16px rgba(233,30,140,.5))"}} />
            <div><div className="login-brand">Vidvana <span style={{color:"var(--ac)",fontWeight:800}}>Sphere</span></div><div style={{ fontSize:9,color:"var(--t3)",letterSpacing:.8,textTransform:"uppercase",marginTop:3,fontWeight:600 }}>Learning Platform</div></div>
          </div>
          <div style={{ display:"flex",justifyContent:"center",marginTop:10 }}><ThemeToggle dk={dk} toggle={toggle} mini /></div>
          <p className="login-sub" style={{ marginTop:12 }}>Sign in to your portal</p>
        </div>
        <div className="fld"><label>Email</label><input type="email" placeholder="Enter your email" value={email} onChange={e=>setEmail(e.target.value)} /></div>
        <div className="fld">
          <label>Password</label>
          <div style={{ position: "relative" }}>
            <input
              type={showPass ? "text" : "password"}
              placeholder="Enter your password"
              value={pass}
              onChange={e => setPass(e.target.value)}
              onKeyDown={e => e.key === "Enter" && doLogin()}
              style={{ paddingRight: 40 }}
            />
            <button
              type="button"
              onClick={() => setShowPass(p => !p)}
              style={{
                position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)",
                background: "none", border: "none", cursor: "pointer", color: "var(--t3)",
                padding: 4, display: "flex", alignItems: "center"
              }}
            >
              {showPass ? IC.eye_off || "🙈" : IC.eye || "👁"}
            </button>
          </div>
        </div>
        {err && <div className="err">{IC.info} {err}</div>}
        <button className="btn-login" onClick={doLogin}>Sign in →</button>
        <p className="hint">Use credentials provided by your admin</p>
        <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px solid var(--b1)", textAlign: "center" }}>
          <p style={{ fontSize: 11, color: "var(--t4)", lineHeight: 1.6 }}>
            For any issue with the portal please contact<br/>
            <span style={{ color: "var(--ac)", fontWeight: 600 }}>+91 9315680410</span> or email us at<br/>
            <a href="mailto:VidvanaLearning@gmail.com" style={{ color: "var(--ac)", fontWeight: 600, textDecoration: "none" }}>VidvanaLearning@gmail.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}

// ─── SIDEBAR ──────────────────────────────────────────────────────────────────
function Sidebar({ user, page, setPage, onLogout, dk, toggle }) {
  const navs = {
    admin: [
      { id:"dashboard",  l:"Dashboard",    ic:IC.home },
      { id:"usermgmt",   l:"Manage Users", ic:IC.people },
      { id:"usermapping",l:"Users Mapping",ic:IC.rep },
      { id:"classrecord",l:"Class Record", ic:IC.cal },
      { id:"chat",       l:"Messages",     ic:IC.chat },
      { id:"support",    l:"Help Desk",    ic:IC.help },
      { id:"guidelines", l:"Guidelines",   ic:IC.guide },
    ],
    coordinator: [
      { id:"dashboard",   l:"Dashboard", ic:IC.home },
      { id:"schedule",    l:"Manage Schedule", ic:IC.cal },
      { id:"students",    l:"All Students", ic:IC.people },
      { id:"teachers",    l:"All Teachers", ic:IC.people },
      { id:"files",       l:"Files", ic:IC.file },
      { id:"chat",        l:"Messages", ic:IC.chat },
      { id:"support",     l:"Help Desk", ic:IC.help },
      { id:"guidelines",  l:"Guidelines", ic:IC.guide },
    ],
    teacher: [
      { id:"dashboard",  l:"Dashboard", ic:IC.home },
      { id:"myclasses",  l:"My Classes", ic:IC.cal },
      { id:"mystudents", l:"My Students", ic:IC.people },
      { id:"chat",       l:"Chat", ic:IC.chat },
      { id:"files",      l:"Files", ic:IC.file },
      { id:"attendance", l:"Attendance", ic:IC.att },
      { id:"support",    l:"Help Desk", ic:IC.help },
      { id:"guidelines", l:"Guidelines", ic:IC.guide },
    ],
    student: [
      { id:"dashboard",  l:"Dashboard", ic:IC.home },
      { id:"myclasses",  l:"My Classes", ic:IC.cal },
      { id:"myteachers", l:"My Teachers", ic:IC.people },
      { id:"chat",       l:"Chat", ic:IC.chat },
      { id:"files",      l:"Files", ic:IC.file },
      { id:"attendance", l:"Attendance", ic:IC.att },
      { id:"support",    l:"Help Desk", ic:IC.help },
      { id:"guidelines", l:"Guidelines", ic:IC.guide },
    ],
  };
  const rl = user.role==="admin"?"Administrator":user.role==="coordinator"?"Coordinator":user.role==="teacher"?user.subject:user.grade;
  const avC = user.role==="admin"?"av-c":user.role==="coordinator"?"av-c":user.role==="teacher"?"av-t":"av-s";
  return (
    <div className="sb">
      <div className="sb-logo">
        <img src={LOGO_B64} alt="Vidvana Sphere" style={{width:48,height:40,objectFit:"contain",flexShrink:0,filter:"drop-shadow(0 2px 8px rgba(233,30,140,.4))"}} />
        <div><div className="sb-brand">Vidvana <span style={{color:"var(--ac)",fontWeight:800}}>Sphere</span></div><div className="sb-tagline">Learning Platform</div></div>
      </div>
      <div className="sb-user">
        <div className={`av ${avC}`} style={{ width:34,height:34,fontSize:11 }}>{user.initials}</div>
        <div style={{ flex:1,minWidth:0 }}><div className="sb-uname">{user.name}</div><div className="sb-urole">{rl}</div></div>
      </div>
      <div className="sb-nav">
        {(navs[user.role]||[]).map(item => (
          <div key={item.id} className={`ni ${page===item.id?"on":""}`} onClick={()=>setPage(item.id)}>
            {item.ic}<span style={{ flex:1 }}>{item.l}</span>
          </div>
        ))}
      </div>
      <div className="sb-foot">
        <ThemeToggle dk={dk} toggle={toggle} />
        <div style={{ height:4 }} />
        <button className="lg-btn" onClick={onLogout}>{IC.out}<span>Sign out</span></button>
      </div>
    </div>
  );
}

// ─── DASHBOARD ────────────────────────────────────────────────────────────────
function Dashboard({ user, classes, setPage, allUsers }) {
  const DonutChart = ({ data, title }) => {
    const total = data.reduce((s, d) => s + d.value, 0);
    let cumPct = 0;
    if (total === 0) return (
      <div className="card" style={{ flex: 1, minWidth: 250, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <div className="card-title" style={{ width: "100%", textAlign: "left", marginBottom: 16 }}>{title}</div>
        <div style={{ color:"var(--t3)", padding: "40px 0" }}>No data</div>
      </div>
    );
    return (
      <div className="card" style={{ flex: 1, minWidth: 250 }}>
        <div className="card-title" style={{ marginBottom: 16 }}>{title}</div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 20 }}>
          <svg viewBox="0 0 36 36" style={{ width: 120, height: 120, transform: "rotate(-90deg)" }}>
            {data.map((d, i) => {
              if (d.value === 0) return null;
              const pct = (d.value / total) * 100;
              const dasharray = `${pct} ${100 - pct}`;
              const dashoffset = -cumPct;
              cumPct += pct;
              return (
                <circle key={i} r="15.91549430918954" cx="18" cy="18" fill="transparent"
                  stroke={d.color} strokeWidth="4" strokeDasharray={dasharray} strokeDashoffset={dashoffset}
                />
              );
            })}
          </svg>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {data.map((d, i) => d.value > 0 && (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "var(--t2)" }}>
                <div style={{ width: 10, height: 10, borderRadius: "50%", background: d.color }}></div>
                <span style={{ fontWeight: 600 }}>{d.label}:</span> {d.value}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const BarChart = ({ data, title }) => {
    const maxVal = Math.max(...data.map(d => d.value), 1);
    if (data.length === 0) return (
      <div className="card" style={{ flex: 1, minWidth: 250, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <div className="card-title" style={{ width: "100%", textAlign: "left", marginBottom: 16 }}>{title}</div>
        <div style={{ color:"var(--t3)", padding: "40px 0" }}>No data</div>
      </div>
    );
    return (
      <div className="card" style={{ flex: 1, minWidth: 250 }}>
        <div className="card-title" style={{ marginBottom: 16 }}>{title}</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {data.map((d, i) => d.value > 0 && (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 80, fontSize: 11, color: "var(--t2)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={d.label}>{d.label}</div>
              <div style={{ flex: 1, height: 16, background: "var(--s3)", borderRadius: 4, overflow: "hidden" }}>
                <div style={{ width: `${(d.value/maxVal)*100}%`, height: "100%", background: d.color, borderRadius: 4 }}></div>
              </div>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--t1)", width: 20, textAlign: "right" }}>{d.value}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const myCls = user.role === "coordinator" ? classes
    : user.role === "teacher" ? classes.filter(c => c.tId === user.id)
    : classes.filter(c => c.sIds?.includes(user.id));

  const done = myCls.filter(c => c.done);
  const upcomingRaw = myCls.filter(c => !c.done);
  const upcoming = [...upcomingRaw].sort((a, b) => {
    const d1 = new Date(`${a.date}T${a.time}:00`);
    const d2 = new Date(`${b.date}T${b.time}:00`);
    return d1 - d2;
  });
  const next = upcoming[0];
  const pct = myCls.length ? Math.round(done.length / myCls.length * 100) : 0;
  const la = next ? linkActive(next, user) : false;
  const ls = next ? clsStatus(next) : null;

  const coordTeacherStats = allUsers.teachers.map(t => ({
    teacher: t,
    students: allUsers.students.filter(s => t.students?.includes(s.id)),
    classesDone: classes.filter(c => c.tId === t.id && c.done).length,
    classesTotal: classes.filter(c => c.tId === t.id).length,
  }));

  const ProfileCard = () => {
    if (user.role === "admin") {
      return (
        <div className="pro-card">
          <div className="pro-inner">
            <div className="pro-av av av-c">{user.initials}</div>
            <div style={{ flex:1 }}>
              <div style={{ fontFamily:"var(--fs)",fontSize:20,color:"var(--t1)",marginBottom:6 }}>{user.name}</div>
              <div style={{ display:"flex",flexWrap:"wrap",gap:5,marginBottom:8 }}>
                <span className="bdg bdg-vi">Admin</span>
                <span className="bdg bdg-em">Super Access</span>
              </div>
              <div className="prow">{IC.mail} {user.email}</div>
              <div className="prow">{IC.phone} {user.phone}</div>
            </div>
          </div>
        </div>
      );
    }
    if (user.role === "student") {
      const myTs = allUsers.teachers.filter(t => user.teachers?.includes(t.id));
      return (
        <div className="pro-card">
          <div className="pro-inner">
            <div className={`pro-av av ${user.role==="student"?"av-s":"av-t"}`}>{user.initials}</div>
            <div style={{ flex:1 }}>
              <div style={{ fontFamily:"var(--fs)",fontSize:20,color:"var(--t1)",marginBottom:6 }}>{user.name}</div>
              <div style={{ display:"flex",flexWrap:"wrap",gap:5,marginBottom:8 }}>
                <span className="bdg bdg-ac">{user.grade}</span>
                <span className="bdg bdg-cy">{user.tzL} · {nowTZ(user.tz)}</span>
              </div>
              <div className="prow">{IC.loc} {user.location}</div>
              <div className="prow">{IC.globe} {user.country}</div>
              <div className="prow">{IC.mail} {user.email}</div>
              <div style={{ marginTop:8 }}>
                <div className="section-label">Your teachers</div>
                {myTs.length===0 ? <span style={{fontSize:12,color:"var(--t4)"}}>None assigned</span>
                  : myTs.map(t => <span key={t.id} className="chip">{t.name}</span>)}
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (user.role === "teacher") {
      const mySs = allUsers.students.filter(s => user.students?.includes(s.id));
      return (
        <div className="pro-card">
          <div className="pro-inner">
            <div className="pro-av av av-t">{user.initials}</div>
            <div style={{ flex:1 }}>
              <div style={{ fontFamily:"var(--fs)",fontSize:20,color:"var(--t1)",marginBottom:6 }}>{user.name}</div>
              <div style={{ display:"flex",flexWrap:"wrap",gap:5,marginBottom:8 }}>
                <span className="bdg bdg-ac">{user.subject}</span>
                <span className="bdg bdg-cy">{user.tzL} · {nowTZ(user.tz)}</span>
              </div>
              <div className="prow">{IC.phone} {user.phone}</div>
              <div className="prow">{IC.mail} {user.email}</div>
              <div className="prow">{IC.loc} {user.location}</div>
              <div style={{ marginTop:8 }}>
                <div className="section-label">Your students</div>
                {mySs.length===0 ? <span style={{fontSize:12,color:"var(--t4)"}}>None assigned</span>
                  : mySs.map(s => <span key={s.id} className="chip">{s.name} · {s.grade}</span>)}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="pro-card">
        <div className="pro-inner">
          <div className="pro-av av av-c">{user.initials}</div>
          <div style={{ flex:1 }}>
            <div style={{ fontFamily:"var(--fs)",fontSize:20,color:"var(--t1)",marginBottom:6 }}>{user.name}</div>
            <div style={{ display:"flex",flexWrap:"wrap",gap:5,marginBottom:8 }}>
              <span className="bdg bdg-vi">Coordinator</span>
              <span className="bdg bdg-em">Full Platform Access</span>
            </div>
            <div className="prow">{IC.mail} {user.email}</div>
            <div className="prow">{IC.phone} {user.phone}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="vcol">
      <ProfileCard />
      {user.role === "admin" ? (
        <div className="vcol" style={{gap:12}}>
          <div className="grid4">
            <div className="stile vi"><div className="st-lbl">Coordinators</div><div className="st-val">{allUsers.coordinators?.length || 0}</div><div className="st-sub">Active</div></div>
            <div className="stile ac"><div className="st-lbl">Teachers</div><div className="st-val">{allUsers.teachers?.length || 0}</div><div className="st-sub">Active educators</div></div>
            <div className="stile em"><div className="st-lbl">Students</div><div className="st-val">{allUsers.students?.length || 0}</div><div className="st-sub">Enrolled learners</div></div>
            <div className="stile wa"><div className="st-lbl">Total Users</div><div className="st-val">{(allUsers.admins?.length || 0) + (allUsers.coordinators?.length || 0) + (allUsers.teachers?.length || 0) + (allUsers.students?.length || 0)}</div><div className="st-sub">All roles</div></div>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
            {(() => {
              const colors = ["#e91e63", "#9c27b0", "#3f51b5", "#03a9f4", "#009688", "#ff9800", "#f44336", "#4caf50", "#cddc39", "#8bc34a"];
              
              const students = allUsers.students || [];
              const teachers = allUsers.teachers || [];
              
              const countryMap = {};
              students.forEach(s => { const c = s.country || "Unknown"; countryMap[c] = (countryMap[c] || 0) + 1; });
              const countryData = Object.entries(countryMap).map(([label, value], i) => ({ label, value, color: colors[i % colors.length] }));
              
              const gradeMap = {};
              students.forEach(s => { const g = s.grade || "Unknown"; gradeMap[g] = (gradeMap[g] || 0) + 1; });
              const gradeData = Object.entries(gradeMap).map(([label, value], i) => ({ label, value, color: colors[i % colors.length] }));
              
              const subjectMap = {};
              teachers.forEach(t => { 
                if (t.subject) {
                  t.subject.split(", ").forEach(sub => {
                    const trimmed = sub.trim();
                    if (trimmed) subjectMap[trimmed] = (subjectMap[trimmed] || 0) + 1;
                  });
                } else {
                  subjectMap["Unknown"] = (subjectMap["Unknown"] || 0) + 1;
                }
              });
              const subjectData = Object.entries(subjectMap).map(([label, value], i) => ({ label, value, color: colors[i % colors.length] }));
              
              return (
                <>
                  <DonutChart data={countryData} title="Students by Country" />
                  <DonutChart data={gradeData} title="Students by Grade" />
                  <BarChart data={subjectData} title="Teachers by Subject" />
                </>
              );
            })()}
          </div>
        </div>
      ) : user.role === "coordinator" ? (
        <div className="vcol" style={{gap:12}}>
          <div className="grid3">
            <div className="stile vi"><div className="st-lbl">Total Teachers</div><div className="st-val">{allUsers.teachers.length}</div><div className="st-sub">Active educators</div></div>
            <div className="stile ac"><div className="st-lbl">Total Students</div><div className="st-val">{allUsers.students.length}</div><div className="st-sub">Enrolled learners</div></div>
            <div className="stile em"><div className="st-lbl">Classes Conducted</div><div className="st-val">{classes.filter(c=>c.done).length}</div><div className="st-sub">Out of {classes.length} total</div></div>
          </div>
          {(() => {
            const now = new Date();
            const currentMonthKey = now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0");
            const currentMonthName = now.toLocaleDateString("en-IN", { month: "long", year: "numeric" });
            const myTeachers = allUsers.teachers || [];
            const teacherData = myTeachers.map(t => {
              const tClasses = classes.filter(c => c.tId === t.id && c.date && c.date.startsWith(currentMonthKey));
              const tdone = tClasses.filter(c => c.done).length;
              const total = tClasses.length;
              return { name: t.name, subject: t.subject, done: tdone, total, pending: total - tdone };
            });
            const maxTotal = Math.max(...teacherData.map(t => t.total), 1);
            return (
              <div className="card">
                <div className="card-title" style={{ marginBottom: 16 }}>
                  {IC.cal} Teacher Classes — {currentMonthName}
                </div>
                {teacherData.length === 0 && <div className="empty"><div className="empty-icon">👤</div>No teachers assigned</div>}
                {teacherData.map(t => (
                  <div key={t.name} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: "1px solid var(--b1)" }}>
                    <div style={{ width: 100, minWidth: 100 }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "var(--t1)" }}>{t.name}</div>
                      <div style={{ fontSize: 10, color: "var(--t3)" }}>{t.subject}</div>
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex", height: 20, borderRadius: 4, overflow: "hidden", background: "var(--s3)" }}>
                        {t.done > 0 && <div style={{ width: (t.done / maxTotal) * 100 + "%", background: "var(--em)", transition: "width 0.3s" }} />}
                        {t.pending > 0 && <div style={{ width: (t.pending / maxTotal) * 100 + "%", background: "var(--wa)", transition: "width 0.3s" }} />}
                      </div>
                    </div>
                    <div style={{ minWidth: 80, textAlign: "right" }}>
                      <span style={{ fontSize: 13, fontWeight: 700, color: "var(--em)" }}>{t.done}</span>
                      <span style={{ fontSize: 11, color: "var(--t3)" }}> / {t.total}</span>
                    </div>
                  </div>
                ))}
                <div style={{ marginTop: 10, display: "flex", gap: 16, fontSize: 11, color: "var(--t3)" }}>
                  <span><span style={{ display: "inline-block", width: 10, height: 10, borderRadius: 2, background: "var(--em)", marginRight: 4 }}></span>Completed</span>
                  <span><span style={{ display: "inline-block", width: 10, height: 10, borderRadius: 2, background: "var(--wa)", marginRight: 4 }}></span>Pending</span>
                </div>
              </div>
            );
          })()}
          {(() => {
            const months = [];
            const now = new Date();
            for (let i = 5; i >= 0; i--) {
              const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
              const monthKey = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0");
              const monthName = d.toLocaleDateString("en-IN", { month: "short", year: "numeric" });
              const count = classes.filter(c => {
                if (!c.done || !c.date) return false;
                return c.date.startsWith(monthKey);
              }).length;
              months.push({ key: monthKey, name: monthName, count });
            }
            const maxCount = Math.max(...months.map(m => m.count), 1);
            return (
              <div className="card">
                <div className="card-title" style={{ marginBottom: 16 }}>
                  {IC.cal} Monthly Classes Completed
                </div>
                <div style={{ display: "flex", alignItems: "flex-end", gap: 8, height: 180, padding: "0 10px" }}>
                  {months.map(m => (
                    <div key={m.key} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                      <span style={{ fontSize: 12, fontWeight: 700, color: m.count > 0 ? "var(--ac)" : "var(--t4)" }}>
                        {m.count}
                      </span>
                      <div style={{
                        width: "100%", maxWidth: 60,
                        height: m.count > 0 ? Math.max((m.count / maxCount) * 140, 8) : 4,
                        background: m.count > 0 ? "linear-gradient(180deg, var(--ac), var(--vi))" : "var(--b1)",
                        borderRadius: "6px 6px 2px 2px", transition: "height 0.5s ease", minHeight: 4,
                      }} />
                      <span style={{ fontSize: 10, color: "var(--t3)", textAlign: "center", lineHeight: 1.2 }}>
                        {m.name}
                      </span>
                    </div>
                  ))}
                </div>
                <div style={{ marginTop: 14, paddingTop: 12, borderTop: "1px solid var(--b1)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontSize: 12, color: "var(--t3)" }}>Total classes (last 6 months)</span>
                  <span style={{ fontSize: 16, fontWeight: 700, color: "var(--t1)" }}>
                    {months.reduce((sum, m) => sum + m.count, 0)}
                  </span>
                </div>
              </div>
            );
          })()}
          <div className="card">
            <div className="card-title" style={{marginBottom:14}}>{IC.people} Teacher · Student overview</div>
            {coordTeacherStats.map(({teacher,students,classesDone,classesTotal}) => (
              <div key={teacher.id} style={{padding:"12px 14px",background:"var(--s2)",border:"1px solid var(--b1)",borderRadius:12,marginBottom:8}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                  <div className="av av-t" style={{width:34,height:34,fontSize:11}}>{teacher.initials}</div>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:700,fontSize:13,color:"var(--t1)"}}>{teacher.name}</div>
                    <div style={{fontSize:11,color:"var(--t3)"}}>{teacher.subject} · {classesDone}/{classesTotal} classes done</div>
                  </div>
                  <span className="bdg bdg-ac">{students.length} student{students.length!==1?"s":""}</span>
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                  {students.map(s => (
                    <div key={s.id} style={{display:"flex",alignItems:"center",gap:5,padding:"4px 10px",background:"var(--s3)",borderRadius:20,border:"1px solid var(--b1)"}}>
                      <div className="av av-s" style={{width:18,height:18,fontSize:7}}>{s.initials}</div>
                      <span style={{fontSize:11,color:"var(--t2)",fontWeight:500}}>{s.name}</span>
                      <span style={{fontSize:10,color:"var(--t4)"}}>{s.grade}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <>
        <div className="grid4">
          <div className="stile ac"><div className="st-lbl">Total classes</div><div className="st-val">{myCls.length}</div><div className="st-sub">All time</div></div>
          <div className="stile em"><div className="st-lbl">Completed</div><div className="st-val">{done.length}</div><div className="st-sub">Classes done</div></div>
          <div className="stile wa"><div className="st-lbl">Upcoming</div><div className="st-val">{upcoming.length}</div><div className="st-sub">Scheduled</div></div>
          <div className="stile vi"><div className="st-lbl">Attendance</div><div className="st-val">{pct}%</div><div className="st-sub">Completion rate</div></div>
        </div>
        {user.role === "student" && (() => {
          const now = new Date();
          const currentMonthKey = now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0");
          const completedThisMonth = myCls.filter(c => c.done && c.date && c.date.startsWith(currentMonthKey)).length;
          const scheduledThisMonth = myCls.filter(c => !c.done && c.date && c.date.startsWith(currentMonthKey)).length;
          const totalThisMonth = completedThisMonth + scheduledThisMonth;
          const progressPercent = totalThisMonth === 0 ? 0 : Math.min(Math.round((completedThisMonth / totalThisMonth) * 100), 100);
          const currentMonthName = now.toLocaleDateString("en-IN", { month: "long", year: "numeric" });
          return (
            <div className="card" style={{ borderColor: progressPercent >= 100 && totalThisMonth > 0 ? "var(--em)" : progressPercent >= 50 ? "var(--ac)" : "var(--wa)" }}>
              <div className="card-title" style={{ marginBottom: 14 }}>
                {IC.cal} Monthly Class Progress — {currentMonthName}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 16 }}>
                <div style={{
                  width: 80, height: 80, borderRadius: "50%",
                  background: `conic-gradient(${progressPercent >= 100 && totalThisMonth > 0 ? "var(--em)" : "var(--ac)"} ${progressPercent * 3.6}deg, var(--s3) 0deg)`,
                  display: "flex", alignItems: "center", justifyContent: "center", position: "relative"
                }}>
                  <div style={{
                    width: 60, height: 60, borderRadius: "50%", background: "var(--s1)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 18, fontWeight: 700, color: progressPercent >= 100 && totalThisMonth > 0 ? "var(--em)" : "var(--ac)"
                  }}>
                    {progressPercent}%
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: "var(--t1)", marginBottom: 6 }}>
                    {completedThisMonth} of {totalThisMonth} classes completed
                  </div>
                  <div style={{ display: "flex", gap: 12 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--em)" }} />
                      <span style={{ fontSize: 11, color: "var(--t3)" }}>Done: {completedThisMonth}</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--wa)" }} />
                      <span style={{ fontSize: 11, color: "var(--t3)" }}>Scheduled: {scheduledThisMonth}</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--b2)" }} />
                      <span style={{ fontSize: 11, color: "var(--t3)" }}>Remaining: {Math.max(totalThisMonth - completedThisMonth, 0)}</span>
                    </div>
                  </div>
                  <div style={{ marginTop: 8, height: 6, background: "var(--s3)", borderRadius: 3, overflow: "hidden" }}>
                    <div style={{
                      height: "100%", width: progressPercent + "%",
                      background: progressPercent >= 100 && totalThisMonth > 0 ? "var(--em)" : "linear-gradient(90deg, var(--ac), var(--vi))",
                      borderRadius: 3, transition: "width 0.5s ease"
                    }} />
                  </div>
                </div>
              </div>
              {progressPercent >= 100 && totalThisMonth > 0 && (
                <div style={{ padding: "8px 14px", background: "var(--em2)", borderRadius: 8, fontSize: 12, color: "var(--em)", display: "flex", alignItems: "center", gap: 6 }}>
                  {IC.check} All scheduled classes for this month are completed! Great job!
                </div>
              )}
            </div>
          );
        })()}
        {user.role === "teacher" && (() => {
          const now = new Date();
          const currentMonthKey = now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0");
          const currentMonthName = now.toLocaleDateString("en-IN", { month: "long", year: "numeric" });
          const myStudents = allUsers.students.filter(s => (user.students || []).includes(s.id));
          return (
            <div className="card">
              <div className="card-title" style={{ marginBottom: 14 }}>
                {IC.people} Student Class Progress — {currentMonthName}
              </div>
              {myStudents.length === 0 && <div className="empty"><div className="empty-icon">👤</div>No students assigned</div>}
              {myStudents.map(s => {
                const studentClasses = classes.filter(c => c.tId === user.id && (c.sIds || []).includes(s.id) && c.date && c.date.startsWith(currentMonthKey));
                const cycleTarget = studentClasses.length;
                const completed = studentClasses.filter(c => c.done).length;
                const progressPercent = cycleTarget === 0 ? 0 : Math.min(Math.round((completed / cycleTarget) * 100), 100);
                return (
                  <div key={s.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", background: "var(--s2)", border: "1px solid var(--b1)", borderRadius: 10, marginBottom: 6 }}>
                    <div className="av av-s" style={{ width: 32, height: 32, fontSize: 10 }}>{s.initials}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 500, color: "var(--t1)" }}>{s.name}</div>
                      <div style={{ fontSize: 11, color: "var(--t3)" }}>{completed}/{cycleTarget} classes · {progressPercent}%</div>
                    </div>
                    <div style={{ width: 80, height: 6, background: "var(--s3)", borderRadius: 3, overflow: "hidden" }}>
                      <div style={{ height: "100%", width: progressPercent + "%", background: progressPercent >= 100 ? "var(--em)" : "linear-gradient(90deg, var(--ac), var(--vi))", borderRadius: 3 }} />
                    </div>
                    <span className={`bdg ${progressPercent >= 100 ? "bdg-em" : progressPercent >= 50 ? "bdg-ac" : "bdg-wa"}`} style={{ minWidth: 40, justifyContent: "center" }}>
                      {progressPercent}%
                    </span>
                  </div>
                );
              })}
            </div>
          );
        })()}
        </>
      )}
      {next && user.role !== "coordinator" && (
        <div className="card" style={{ borderColor: ls==="live"?"var(--em)":ls==="soon"?"var(--ac)":undefined }}>
          <div className="card-hd">
            <div className="card-title">
              {ls==="live" && <span className="pulse" />}
              {ls==="live" ? "Class in progress" : ls==="soon" ? "Starting soon" : "Your next class"}
            </div>
          </div>
          <div style={{ display:"flex",alignItems:"center",gap:13 }}>
            <div className={`cind ${ls==="live"?"i-em":ls==="soon"?"i-ac":"i-wa"}`} style={{ width:10,height:10 }} />
            <div style={{ flex:1 }}>
              <div style={{ fontFamily:"var(--fs)",fontSize:18,color:"var(--t1)" }}>{next.title}</div>
              <div style={{ fontSize:12,color:"var(--t3)",marginTop:3 }}>
                {fmtDate(next.date)} · <TimeDisplay c={next} user={user} allUsers={allUsers} /> · {next.dur} min
                {user.tz && <> · <span style={{ color:"var(--ac)",fontWeight:500 }}>{nowTZ(user.tz)} {user.tzL}</span></>}
              </div>
            </div>
            {la
              ? <a href={next.link} target="_blank" rel="noreferrer"><button className="btn btn-em">{IC.meet} Join Meet</button></a>
              : <button className="btn btn-gh" disabled>{IC.clock} Opens on class day</button>}
          </div>
        </div>
      )}
      {user.role !== "coordinator" && user.role !== "admin" && <div className="card">
        <div className="card-hd">
          <div className="card-title">Recent completed classes</div>
          <button className="btn btn-gh btn-sm" onClick={()=>setPage("attendance")}>View all →</button>
        </div>
        {done.slice(0,4).map(c => (
          <div key={c.id} className="crow">
            <div className="cind i-dn" />
            <div className="cr-info"><div className="cr-name">{c.title}</div><div className="cr-meta">{fmtDate(c.date)} · <TimeDisplay c={c} user={user} allUsers={allUsers} /></div></div>
            <span className="bdg bdg-em">{IC.check} Done</span>
          </div>
        ))}
        {done.length===0 && <div className="empty"><div className="empty-icon">📚</div>No completed classes yet</div>}
      </div>}
    </div>
  );
}

// ─── SCHEDULE (Coordinator only) ──────────────────────────────────────────────
function SchedulePage({ classes, showToast, allUsers, user }) {
  const [selD, setSelD] = useState(toDS(new Date()));
  const [md, setMd] = useState(new Date());
  const [modal, setModal] = useState(false);
  const [editC, setEditC] = useState(null);
  const [expandedStudent, setExpandedStudent] = useState(null);
  const emptyFm = () => ({ title:"", date:selD, time:"10:00", dur:"60", link:"", tId:allUsers.teachers[0]?.id||"", sIds:[], recur:false, cnt:1 });
  const [fm, setFm] = useState(emptyFm());

  const yr=md.getFullYear(),mo=md.getMonth();
  const fd=new Date(yr,mo,1).getDay(),dim=new Date(yr,mo+1,0).getDate(),pd=new Date(yr,mo,0).getDate();
  const cells=[];
  for(let i=fd-1;i>=0;i--) cells.push({d:pd-i,c:false});
  for(let d=1;d<=dim;d++) cells.push({d,c:true});
  while(cells.length%7!==0) cells.push({d:cells.length-fd-dim+1,c:false});
  const cds=new Set(classes.map(c=>c.date)),today=toDS(new Date()),selCls=classes.filter(c=>c.date===selD);

  const openNew = () => { setEditC(null); setFm({...emptyFm(),date:selD}); setModal(true); };
  const openEdit = cls => { setEditC(cls); setFm({title:cls.title,date:cls.date,time:cls.time,dur:String(cls.dur),link:cls.link,tId:cls.tId,sIds:cls.sIds||[],recur:false,cnt:1}); setModal(true); };
  const delCls = async id => { await deleteDoc(doc(db, "classes", id)); showToast("Class deleted."); };

  const save = async () => {
    if (!fm.title||!fm.time||fm.sIds.length===0) return;
    if (!fm.link || !fm.link.trim()) { showToast("Please enter the Google Meet link"); return; }
    if (editC) {
      await updateDoc(doc(db, "classes", editC.id), {...fm, dur: parseInt(fm.dur)||60});
      showToast("Class updated successfully!");
    } else {
      const scheduledTZ  = user?.tz  || "Asia/Kolkata";
      const scheduledTZL = user?.tzL || "IST";
      const base=new Date(fm.date+"T00:00:00"),cnt=fm.recur?Math.min(parseInt(fm.cnt)||1,10):1;
      for(let i=0;i<cnt;i++){
        const d=addD(base,i*7);
        const dateStr=toDS(d);
        await addDoc(collection(db, "classes"), {title:fm.title,date:dateStr,time:fm.time,dur:parseInt(fm.dur)||60,tId:fm.tId,sIds:fm.sIds,link:fm.link,scheduledTZ,scheduledTZL,done:false,teacherDone:false,studentDone:false,ts:null,series:cnt>1?Date.now()+i:null});
      }
      showToast(cnt>1?`${cnt} recurring classes scheduled!`:"Class scheduled successfully!");
    }
    setModal(false);
  };

  const [showTZConverter, setShowTZConverter] = useState(false);
  const [fromTZ, setFromTZ] = useState("Asia/Kolkata");
  const [toTZ, setToTZ] = useState("America/New_York");

  const convertTime = (time, from, to) => {
    if (!time) return { time: "--:--", date: "" };
    try {
      const today = new Date().toISOString().split("T")[0];
      const dateStr = fm.date || today;
      const dt = new Date(dateStr + "T" + time + ":00");
      const toTime = dt.toLocaleString("en-US", { timeZone: to, hour: "2-digit", minute: "2-digit", hour12: true });
      const toDate = dt.toLocaleDateString("en-US", { timeZone: to, weekday: "short", month: "short", day: "numeric" });
      return { time: toTime, date: toDate };
    } catch (e) {
      return { time: "--:--", date: "" };
    }
  };

  const togStu = id => setFm(f=>({...f,sIds:f.sIds.includes(id)?f.sIds.filter(x=>x!==id):[...f.sIds,id]}));
  const selT = allUsers.teachers.find(t=>t.id===fm.tId);
  const eligStu = selT ? allUsers.students.filter(s=>selT.students?.includes(s.id)) : allUsers.students;

  return (
    <div className="grid2" style={{ gap:16,alignItems:"start" }}>
      <div className="vcol">
        <div className="card">
          <div className="card-hd">
            <div className="card-title">{IC.cal} {md.toLocaleDateString("en-IN",{month:"long",year:"numeric"})}</div>
            <div className="dp" style={{gap:4}}>
              <button className="btn btn-gh btn-xs" onClick={()=>setMd(new Date(yr,mo-1))}>‹</button>
              <button className="btn btn-gh btn-xs" onClick={()=>setMd(new Date(yr,mo+1))}>›</button>
            </div>
          </div>
          <div className="cal-hdr">{["Su","Mo","Tu","We","Th","Fr","Sa"].map(d=><div key={d} className="cal-dh">{d}</div>)}</div>
          <div className="cal-wrap">
            {cells.map((cell,i)=>{
              const ds=cell.c?`${yr}-${pad(mo+1)}-${pad(cell.d)}`:"";
              return <div key={i} className={`cal-d${!cell.c?" dim":""}${ds===today?" today":""}${ds&&cds.has(ds)?" has":""}${ds===selD?" sel":""}`} onClick={()=>cell.c&&setSelD(ds)}>{cell.d}</div>;
            })}
          </div>
          <button className="btn btn-ac" style={{width:"100%",marginTop:14,justifyContent:"center"}} onClick={openNew}>{IC.plus} Schedule new class</button>
        </div>
        <div className="card">
          <div className="card-title" style={{marginBottom:12}}>{IC.cal} {fmtDate(selD)}</div>
          {selCls.length===0 && <div className="empty"><div className="empty-icon">📅</div>No classes this day</div>}
          {selCls.map(c=>{
            const t=allUsers.teachers.find(x=>x.id===c.tId),ss=allUsers.students.filter(s=>c.sIds?.includes(s.id)),st=clsStatus(c);
            return (
              <div key={c.id} className={`crow${c.done?"":" "+st}`}>
                <div className={`cind ${c.done?"i-dn":st==="live"?"i-em":st==="soon"?"i-ac":"i-wa"}`} />
                <div className="cr-info"><div className="cr-name">{c.title}</div><div className="cr-meta"><TimeDisplay c={c} user={user} allUsers={allUsers} /> · {t?.name} → {ss.map(s=>s.name.split(" ")[0]).join(", ")}</div></div>
                <div className="cr-acts">
                  <button className="btn btn-gh btn-xs" onClick={()=>openEdit(c)}>{IC.edit}</button>
                  <button className="btn btn-er btn-xs" onClick={()=>delCls(c.id)}>{IC.trash}</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="card" style={{ maxHeight:"83vh",overflowY:"auto" }}>
        <div className="card-title" style={{ marginBottom:14 }}>All classes ({classes.length})</div>
        {(() => {
          const studentsMap = {};
          classes.forEach(c => {
            if (c.sIds && c.sIds.length > 0) {
              c.sIds.forEach(sId => {
                if (!studentsMap[sId]) {
                  const s = allUsers.students.find(x => x.id === sId);
                  studentsMap[sId] = { student: s || { id: sId, name: "Unknown" }, classes: [] };
                }
                studentsMap[sId].classes.push(c);
              });
            } else {
               if (!studentsMap["none"]) studentsMap["none"] = { student: { id: "none", name: "Unassigned" }, classes: [] };
               studentsMap["none"].classes.push(c);
            }
          });
          const sortedStudents = Object.values(studentsMap).sort((a,b) => (a.student.name||"").localeCompare(b.student.name||""));
          
          return sortedStudents.map(({ student, classes: studentClasses }) => {
            const sortedClasses = [...studentClasses].sort((a,b) => new Date(a.date) - new Date(b.date));
            const isExpanded = expandedStudent === student.id;
            return (
              <div key={student.id} style={{ marginBottom: 8, border: "1px solid var(--b1)", borderRadius: 8, overflow: "hidden" }}>
                <div 
                  onClick={() => setExpandedStudent(isExpanded ? null : student.id)} 
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "var(--s2)", cursor: "pointer" }}
                >
                  <span style={{ fontWeight: 600, color: "var(--t1)", fontSize: 13 }}>{student.name} <span style={{ fontWeight: 400, color: "var(--t3)", fontSize: 11 }}>({studentClasses.length} class{studentClasses.length !== 1 ? 'es' : ''})</span></span>
                  <span style={{ color: "var(--t3)", fontSize: 10 }}>{isExpanded ? "▲" : "▼"}</span>
                </div>
                {isExpanded && (
                  <div style={{ padding: "10px 14px", background: "var(--bg)" }}>
                    {sortedClasses.map(c => {
                      const t = allUsers.teachers.find(x => x.id === c.tId);
                      const ss = allUsers.students.filter(s => c.sIds?.includes(s.id));
                      return (
                        <div key={c.id} className="crow" style={{ marginBottom: 6 }}>
                          <div className={`cind ${c.done?"i-dn":clsStatus(c)==="live"?"i-em":clsStatus(c)==="soon"?"i-ac":"i-wa"}`} />
                          <div className="cr-info">
                            <div className="cr-name">{c.title}{c.series&&<span className="bdg bdg-vi" style={{marginLeft:6,fontSize:9}}>{IC.rep} Series</span>}</div>
                            <div className="cr-meta">{fmtDate(c.date)} · <TimeDisplay c={c} user={user} allUsers={allUsers} /> · {t?.name} → {ss.map(s=>s.name.split(" ")[0]).join(", ")}</div>
                          </div>
                          <div className="cr-acts">
                            <span className={`bdg ${c.done?"bdg-em":clsStatus(c)==="live"?"bdg-em":clsStatus(c)==="soon"?"bdg-ac":(c.teacherDone||c.studentDone)?"bdg-wa":"bdg-gy"}`}>
                              {c.done?"Done":clsStatus(c)==="live"?"Live":clsStatus(c)==="soon"?"Soon":c.teacherDone&&!c.studentDone?"Pend. Student":!c.teacherDone&&c.studentDone?"Pend. Teacher":"Sched."}
                            </span>
                            <button className="btn btn-gh btn-xs" onClick={()=>openEdit(c)}>{IC.edit}</button>
                            <button className="btn btn-er btn-xs" onClick={()=>delCls(c.id)}>{IC.trash}</button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          });
        })()}
      </div>

      {modal && (
        <div className="ovl" onClick={e=>e.target===e.currentTarget&&setModal(false)}>
          <div className="mdl">
            <div className="mdl-title">{IC.cal} {editC?"Reschedule class":"Schedule a class"}</div>
            <div className="fld"><label>Class topic</label><input placeholder="e.g. Quadratic Equations" value={fm.title} onChange={e=>setFm(f=>({...f,title:e.target.value}))} /></div>
            <div className="mgrid">
              <div className="fld"><label>Date</label><input type="date" value={fm.date} onChange={e=>setFm(f=>({...f,date:e.target.value}))} /></div>
              <div className="fld"><label>Time</label><input type="time" value={fm.time} onChange={e=>setFm(f=>({...f,time:e.target.value}))} /></div>
            </div>
            <div className="mgrid">
              <div className="fld"><label>Duration (mins)</label><input type="number" value={fm.dur} min={30} max={180} onChange={e=>setFm(f=>({...f,dur:e.target.value}))} /></div>
              <div className="fld" style={{marginBottom:0}}>
                <label>Google Meet Link *</label>
                <input value={fm.link} onChange={e=>setFm(f=>({...f,link:e.target.value}))} placeholder="Paste the entire Google Meet link here" required />
                <p style={{fontSize:11,color:"var(--t3)",marginTop:4,marginBottom:0}}>Go to meet.google.com → New meeting → Create a meeting for later → Copy and paste the link here</p>
              </div>
            </div>
            <div style={{ marginTop: 4, marginBottom: 12 }}>
              <button type="button" className="btn btn-gh btn-sm" onClick={() => setShowTZConverter(p => !p)} style={{ fontSize: 11 }}>
                {IC.globe} {showTZConverter ? "Hide" : "Show"} Time Zone Converter
              </button>
              {showTZConverter && (() => {
                const tzOptions = [
                  { group: "India", zones: [{ value: "Asia/Kolkata", label: "India (IST)" }] },
                  { group: "USA", zones: [
                    { value: "America/New_York", label: "USA Eastern (ET)" },
                    { value: "America/Chicago", label: "USA Central (CT)" },
                    { value: "America/Denver", label: "USA Mountain (MT)" },
                    { value: "America/Los_Angeles", label: "USA Pacific (PT)" },
                    { value: "America/Anchorage", label: "USA Alaska (AKT)" },
                    { value: "Pacific/Honolulu", label: "USA Hawaii (HST)" },
                  ]},
                  { group: "Canada", zones: [
                    { value: "America/Toronto", label: "Canada Eastern (ET)" },
                    { value: "America/Winnipeg", label: "Canada Central (CT)" },
                    { value: "America/Edmonton", label: "Canada Mountain (MT)" },
                    { value: "America/Vancouver", label: "Canada Pacific (PT)" },
                    { value: "America/St_Johns", label: "Canada Newfoundland (NT)" },
                  ]},
                  { group: "Australia", zones: [
                    { value: "Australia/Sydney", label: "Australia Eastern (AEST)" },
                    { value: "Australia/Adelaide", label: "Australia Central (ACST)" },
                    { value: "Australia/Perth", label: "Australia Western (AWST)" },
                    { value: "Australia/Brisbane", label: "Australia Queensland (AEST)" },
                  ]},
                  { group: "New Zealand", zones: [{ value: "Pacific/Auckland", label: "New Zealand (NZST)" }] },
                  { group: "UAE", zones: [{ value: "Asia/Dubai", label: "UAE (GST)" }] },
                ];
                const converted = convertTime(fm.time, fromTZ, toTZ);
                const fromDisplay = convertTime(fm.time, fromTZ, fromTZ);
                return (
                  <div style={{ marginTop: 10, padding: 14, background: "var(--s2)", border: "1px solid var(--b1)", borderRadius: 10 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "var(--t2)", marginBottom: 10, display: "flex", alignItems: "center", gap: 6 }}>
                      {IC.globe} Time Zone Converter
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", gap: 10, alignItems: "center" }}>
                      <div>
                        <label style={{ fontSize: 10, fontWeight: 600, color: "var(--t3)", textTransform: "uppercase", letterSpacing: ".5px", display: "block", marginBottom: 4 }}>From</label>
                        <select value={fromTZ} onChange={e => setFromTZ(e.target.value)} style={{ width: "100%", padding: "6px 8px", background: "var(--s3)", border: "1px solid var(--b1)", borderRadius: 6, color: "var(--t1)", fontSize: 11 }}>
                          {tzOptions.map(g => (
                            <optgroup key={g.group} label={g.group}>
                              {g.zones.map(z => <option key={z.value} value={z.value}>{z.label}</option>)}
                            </optgroup>
                          ))}
                        </select>
                        <div style={{ marginTop: 6, padding: "8px 10px", background: "var(--s3)", borderRadius: 6, textAlign: "center" }}>
                          <div style={{ fontSize: 18, fontWeight: 700, color: "var(--t1)" }}>{fromDisplay.time}</div>
                          <div style={{ fontSize: 10, color: "var(--t3)" }}>{fromDisplay.date}</div>
                        </div>
                      </div>
                      <div style={{ fontSize: 20, color: "var(--ac)", marginTop: 20 }}>→</div>
                      <div>
                        <label style={{ fontSize: 10, fontWeight: 600, color: "var(--t3)", textTransform: "uppercase", letterSpacing: ".5px", display: "block", marginBottom: 4 }}>To</label>
                        <select value={toTZ} onChange={e => setToTZ(e.target.value)} style={{ width: "100%", padding: "6px 8px", background: "var(--s3)", border: "1px solid var(--b1)", borderRadius: 6, color: "var(--t1)", fontSize: 11 }}>
                          {tzOptions.map(g => (
                            <optgroup key={g.group} label={g.group}>
                              {g.zones.map(z => <option key={z.value} value={z.value}>{z.label}</option>)}
                            </optgroup>
                          ))}
                        </select>
                        <div style={{ marginTop: 6, padding: "8px 10px", background: "var(--ac3)", border: "1px solid var(--ac)", borderRadius: 6, textAlign: "center" }}>
                          <div style={{ fontSize: 18, fontWeight: 700, color: "var(--ac)" }}>{converted.time}</div>
                          <div style={{ fontSize: 10, color: "var(--t3)" }}>{converted.date}</div>
                        </div>
                      </div>
                    </div>
                    {fm.time && fromTZ !== toTZ && (
                      <div style={{ marginTop: 8, fontSize: 11, color: "var(--t3)", textAlign: "center" }}>
                        {fm.time} in {fromTZ.split("/").pop().replace(/_/g, " ")} = {converted.time} in {toTZ.split("/").pop().replace(/_/g, " ")}
                        {converted.date !== fromDisplay.date && <span style={{ color: "var(--wa)" }}> (next day)</span>}
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
            <div className="fld"><label>Assign teacher</label>
              <select value={fm.tId} onChange={e=>setFm(f=>({...f,tId:e.target.value,sIds:[]}))}>
                {allUsers.teachers.map(t=><option key={t.id} value={t.id}>{t.name} · {t.subject}</option>)}
              </select>
            </div>
            <div className="fld">
              <label>Assign students</label>
              {eligStu.length===0 && <p style={{fontSize:11.5,color:"var(--wa)",marginTop:4}}>No students assigned to this teacher yet.</p>}
              <div style={{ display:"flex",flexWrap:"wrap",gap:7,marginTop:6 }}>
                {eligStu.map(s=>(
                  <label key={s.id} style={{display:"flex",alignItems:"center",gap:7,cursor:"pointer",padding:"8px 11px",borderRadius:8,background:"var(--s2)",border:`1.5px solid ${fm.sIds.includes(s.id)?"var(--ac)":"var(--b1)"}`}}>
                    <input type="checkbox" checked={fm.sIds.includes(s.id)} onChange={()=>togStu(s.id)} />
                    <span style={{fontSize:12.5}}>{s.name} · {s.grade}</span>
                  </label>
                ))}
              </div>
              {fm.sIds.length===0 && <p style={{fontSize:11,color:"var(--er)",marginTop:6}}>Select at least one student.</p>}
            </div>
            {!editC && (
              <div>
                <div style={{display:"flex",alignItems:"center",gap:8,fontSize:13,padding:"8px 0"}}>
                  <input type="checkbox" style={{cursor:"pointer"}} checked={fm.recur} onChange={e=>setFm(f=>({...f,recur:e.target.checked}))} />
                  <span style={{color: "var(--t3)"}}>{IC.rep} Repeat weekly (multiple classes)</span>
                </div>
                {fm.recur && (
                  <div className="rcb">
                    <span style={{fontSize:12,color:"var(--ac)",fontWeight:500}}>Number of weeks:</span>
                    <select style={{padding:"5px 9px",background:"var(--s2)",border:"1.5px solid var(--b1)",borderRadius:6,color:"var(--t1)",fontSize:12,width:72}} value={fm.cnt} onChange={e=>setFm(f=>({...f,cnt:parseInt(e.target.value)}))}>
                      {[1,2,3,4,5,6,7,8,9,10].map(n=><option key={n} value={n}>{n}</option>)}
                    </select>
                    <span style={{fontSize:11.5,color:"var(--t3)"}}>{fm.cnt} class{fm.cnt>1?"es":""} every {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"][new Date(fm.date+"T00:00:00").getDay()]}</span>
                  </div>
                )}
              </div>
            )}
            <div className="dp" style={{justifyContent:"flex-end",gap:8,marginTop:18}}>
              <button className="btn btn-gh" onClick={()=>setModal(false)}>Cancel</button>
              <button className="btn btn-ac" onClick={save} disabled={fm.sIds.length===0}>{editC?"Save changes →":"Schedule →"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── MY CLASSES (Teacher / Student) ──────────────────────────────────────────
function MyClasses({ user, classes, showToast, allUsers }) {
  const [openSec, setOpenSec] = useState({ today: true, tomorrow: true, upcoming: true, done: true });
  
  const myCls = user.role === "teacher"
    ? classes.filter(c => c.tId === user.id)
    : classes.filter(c => c.sIds?.includes(user.id));

  const upcomingRaw = myCls.filter(c => !c.done);
  const doneRaw = myCls.filter(c => c.done);

  const upcomingSorted = [...upcomingRaw].sort((a, b) => {
    const d1 = new Date(`${a.date}T${a.time}:00`);
    const d2 = new Date(`${b.date}T${b.time}:00`);
    return d1 - d2;
  });

  const done = [...doneRaw].sort((a, b) => {
    const d1 = new Date(`${a.date}T${a.time}:00`);
    const d2 = new Date(`${b.date}T${b.time}:00`);
    return d2 - d1;
  });

  const pad = (n) => String(n).padStart(2, '0');
  const now = new Date();
  const todayStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowStr = `${tomorrow.getFullYear()}-${pad(tomorrow.getMonth() + 1)}-${pad(tomorrow.getDate())}`;

  const todayClasses = upcomingSorted.filter(c => c.date === todayStr);
  const tomorrowClasses = upcomingSorted.filter(c => c.date === tomorrowStr);
  const upcomingClasses = upcomingSorted.filter(c => c.date !== todayStr && c.date !== tomorrowStr);

  const markDone = async id => {
    const cls = classes.find(c => c.id === id);
    if (!cls) return;
    const updates = {};
    if (user.role === "teacher") {
      updates.teacherDone = true;
      if (cls.studentDone) { updates.done = true; updates.ts = new Date().toISOString(); }
    } else if (user.role === "student") {
      updates.studentDone = true;
      if (cls.teacherDone) { updates.done = true; updates.ts = new Date().toISOString(); }
    }
    await updateDoc(doc(db, "classes", id), updates);
    showToast(user.role === "teacher" ? "Marked as done from teacher side" : "Marked as done from student side");
  };

  const renderList = (list, emptyMsg) => {
    if (list.length === 0) return <div className="empty" style={{padding: "16px 0"}}><div className="empty-icon" style={{fontSize: 24}}>📅</div>{emptyMsg}</div>;
    return list.map(c => {
      const st=clsStatus(c),la=linkActive(c, user);
      const teacher = allUsers.teachers.find(t => t.id===c.tId);
      const students = allUsers.students.filter(s => c.sIds?.includes(s.id)).map(s => s.name).join(", ");
      return (
        <div key={c.id} className={`crow ${st==="live"?"live":st==="soon"?"soon":st==="mark"?"mark":""}`}>
          <div className={`cind ${st==="live"?"i-em":st==="soon"?"i-ac":"i-wa"}`} />
          <div className="cr-info">
            <div className="cr-name">{c.title}{c.series&&<span className="bdg bdg-vi" style={{marginLeft:6,fontSize:9}}>{IC.rep}</span>}</div>
            <div className="cr-meta">
              {fmtDate(c.date)} · <TimeDisplay c={c} user={user} allUsers={allUsers} /> · {c.dur} min
              {user.role==="student" && teacher && <> · <span style={{color:"var(--ac)"}}>{teacher.name}</span></>}
              {user.role==="teacher" && students && <> · <span style={{color:"var(--ac)", fontWeight:500}}>{students}</span></>}
            </div>
          </div>
          <div className="cr-acts">
            {la
              ? <a href={c.link} target="_blank" rel="noreferrer"><button className="btn btn-em">{IC.meet} Join Meet</button></a>
              : <button className="btn btn-gh btn-sm" disabled>{IC.clock} Opens on class day</button>}
            {user.role==="teacher" && st==="mark" && (
              !c.teacherDone
                ? <button className="btn btn-wa btn-sm" onClick={()=>markDone(c.id)}>{IC.check} Mark done</button>
                : !c.done ? <span className="bdg bdg-wa" style={{fontSize:10}}>Pending student</span> : null
            )}
            {user.role==="student" && st==="mark" && (
              !c.studentDone
                ? <button className="btn btn-wa btn-sm" onClick={()=>markDone(c.id)}>{IC.check} Mark done</button>
                : !c.done ? <span className="bdg bdg-wa" style={{fontSize:10}}>Pending teacher</span> : null
            )}
          </div>
        </div>
      );
    });
  };

  return (
    <div className="vcol">
      <div className="ban ban-ac">{IC.info} Schedules are managed by your Coordinator. Use the Support tab to request changes.</div>
      
      <div className="card">
        <div className="card-hd" style={{cursor: "pointer", display:"flex", justifyContent:"space-between", alignItems:"center"}} onClick={() => setOpenSec({...openSec, today: !openSec.today})}>
          <div className="card-title">{IC.cal} Today ({todayClasses.length})</div>
          <div style={{fontSize:12, color:"var(--t3)"}}>{openSec.today ? "▼" : "▶"}</div>
        </div>
        {openSec.today && renderList(todayClasses, "No classes scheduled for today")}
      </div>

      <div className="card">
        <div className="card-hd" style={{cursor: "pointer", display:"flex", justifyContent:"space-between", alignItems:"center"}} onClick={() => setOpenSec({...openSec, tomorrow: !openSec.tomorrow})}>
          <div className="card-title">{IC.cal} Tomorrow ({tomorrowClasses.length})</div>
          <div style={{fontSize:12, color:"var(--t3)"}}>{openSec.tomorrow ? "▼" : "▶"}</div>
        </div>
        {openSec.tomorrow && renderList(tomorrowClasses, "No classes scheduled for tomorrow")}
      </div>

      <div className="card">
        <div className="card-hd" style={{cursor: "pointer", display:"flex", justifyContent:"space-between", alignItems:"center"}} onClick={() => setOpenSec({...openSec, upcoming: !openSec.upcoming})}>
          <div className="card-title">{IC.cal} Upcoming Classes ({upcomingClasses.length})</div>
          <div style={{fontSize:12, color:"var(--t3)"}}>{openSec.upcoming ? "▼" : "▶"}</div>
        </div>
        {openSec.upcoming && renderList(upcomingClasses, "No upcoming classes scheduled")}
      </div>

      <div className="card">
        <div className="card-hd" style={{cursor: "pointer", display:"flex", justifyContent:"space-between", alignItems:"center"}} onClick={() => setOpenSec({...openSec, done: !openSec.done})}>
          <div className="card-title">Completed ({done.length})</div>
          <div style={{fontSize:12, color:"var(--t3)"}}>{openSec.done ? "▼" : "▶"}</div>
        </div>
        {openSec.done && (
          done.length===0 
            ? <div className="empty" style={{padding: "16px 0"}}><div className="empty-icon" style={{fontSize: 24}}>✅</div>No completed classes yet</div>
            : done.map(c => (
              <div key={c.id} className="crow">
                <div className="cind i-dn" />
                <div className="cr-info">
                  <div className="cr-name">{c.title}</div>
                  <div className="cr-meta">
                    {fmtDate(c.date)} · <TimeDisplay c={c} user={user} allUsers={allUsers} />
                    {user.role==="teacher" && c.sIds?.length > 0 && <> · <span style={{color:"var(--ac)", fontWeight:500}}>{allUsers.students.filter(s => c.sIds.includes(s.id)).map(s => s.name).join(", ")}</span></>}
                  </div>
                </div>
                <span className="bdg bdg-em">{IC.check} Done</span>
              </div>
            ))
        )}
      </div>
    </div>
  );
}

// ─── CHAT ─────────────────────────────────────────────────────────────────────
function ChatPage({ user, allUsers }) {
  const [inp, setInp] = useState("");
  const [sel, setSel] = useState(null);
  const [coordView, setCoordView] = useState("own");
  const [chatMsgs, setChatMsgs] = useState([]);
  const [unreadCounts, setUnreadCounts] = useState({});
  const [chatFilter, setChatFilter] = useState("all");
  const [chatSearch, setChatSearch] = useState("");
  const [teacherSearch, setTeacherSearch] = useState("");
  const [studentSearch, setStudentSearch] = useState("");
  const bot = useRef(null);

  const coordContact = allUsers.coordinator ? [allUsers.coordinator] : [];
  const contacts = user.role === "teacher"
    ? [...allUsers.students.filter(s => user.students?.includes(s.id)), ...coordContact]
    : user.role === "student"
    ? [...allUsers.teachers.filter(t => user.teachers?.includes(t.id)), ...coordContact]
    : [...allUsers.teachers, ...allUsers.students];

  const allTSPairs = [];
  allUsers.teachers.forEach(t => {
    allUsers.students.filter(s => t.students?.includes(s.id)).forEach(s => {
      allTSPairs.push({ id: `${t.id}-${s.id}`, key: `${t.id}-${s.id}`, label: `${t.name} ↔ ${s.name}`, t, s });
    });
  });

  const getKey = (a, b) => {
    if (a.role === "admin" || b.role === "admin") {
      const adm = a.role === "admin" ? a : b;
      const other = a.role === "admin" ? b : a;
      return `${adm.id}-${other.id}`;
    }
    if (a.role === "coordinator" || b.role === "coordinator") {
      const coord = a.role === "coordinator" ? a : b;
      const other = a.role === "coordinator" ? b : a;
      return `${coord.id}-${other.id}`;
    }
    const t = a.role === "teacher" ? a : b;
    const s = a.role === "student" ? a : b;
    return `${t.id}-${s.id}`;
  };

  const key = sel && !sel.key ? getKey(user, sel) : sel?.key || null;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (!sel && contacts.length > 0) setSel(contacts[0]); }, [contacts.length]);
  useEffect(() => { bot.current?.scrollIntoView({ behavior: "smooth" }); }, [chatMsgs, sel]);

  useEffect(() => {
    if (!key) return;
    const q = query(
      collection(db, "messages"),
      where("chatKey", "==", key),
      orderBy("createdAt", "asc")
    );
    const unsub = onSnapshot(q, (snap) => {
      setChatMsgs(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, [key]);

  useEffect(() => {
    if (!key || !user) return;
    const timer = setTimeout(async () => {
      const q = query(
        collection(db, "messages"),
        where("chatKey", "==", key)
      );
      const snap = await getDocs(q);
      snap.docs.forEach(async (d) => {
        const data = d.data();
        if (data.from !== user.id && (!data.readBy || !data.readBy.includes(user.id))) {
          await updateDoc(doc(db, "messages", d.id), {
            readBy: [...(data.readBy || []), user.id]
          });
        }
      });
    }, 500);
    return () => clearTimeout(timer);
  }, [key, user]);

  useEffect(() => {
    if (!user) return;
    const unsub = onSnapshot(collection(db, "messages"), (snap) => {
      const counts = {};
      snap.docs.forEach(d => {
        const data = d.data();
        if (data.from !== user.id && (!data.readBy || !data.readBy.includes(user.id))) {
          counts[data.chatKey] = (counts[data.chatKey] || 0) + 1;
        }
      });
      setUnreadCounts(counts);
    });
    return () => unsub();
  }, [user]);

  const send = async () => {
    if (!inp.trim() || !key) return;
    const t = new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
    await addDoc(collection(db, "messages"), {
      chatKey: key,
      from: user.id,
      text: inp.trim(),
      t,
      createdAt: new Date(),
      readBy: [user.id]
    });
    setInp("");
  };

  const avClass = r => r === "coordinator" ? "av-c" : r === "teacher" ? "av-t" : "av-s";

  if (user.role === "coordinator" && coordView === "all") {
    return (
      <div className="chat-shell" style={{ flexDirection: "column" }}>
        <div style={{ display: "flex", gap: 4, padding: "10px 12px", borderBottom: "1px solid var(--b1)", background: "var(--s2)", flexShrink: 0 }}>
          <button onClick={() => setCoordView("own")} className="btn btn-gh btn-sm" style={{ flex: 1, justifyContent: "center" }}>My Messages</button>
          <button onClick={() => setCoordView("all")} className="btn btn-ac btn-sm" style={{ flex: 1, justifyContent: "center" }}>Monitor All Chats</button>
        </div>
        <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>
          <div className="chat-list" style={{ overflowY: "auto" }}>
            <div className="chat-list-hd">All conversations</div>
            <div className="chat-contacts">
              {allTSPairs.map(p => (
                <div key={p.id} className={`cc ${sel?.id === p.id ? "sel" : ""}`} onClick={() => setSel(p)}>
                  <div style={{ width: 28, height: 28, borderRadius: "50%", background: "linear-gradient(135deg,#e91e8c,#1565c0)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 700, color: "#fff", flexShrink: 0 }}>👁</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="cc-name" style={{ whiteSpace: "normal", wordWrap: "break-word", lineHeight: 1.4 }}>{p.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="chat-body">
            {sel && sel.key ? (
              <>
                <div className="chat-body-hd">
                  <div style={{ width: 32, height: 32, borderRadius: "50%", background: "linear-gradient(135deg,#e91e8c,#1565c0)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#fff", fontWeight: 700, flexShrink: 0 }}>👁</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, color: "var(--t1)", whiteSpace: "normal", wordWrap: "break-word", lineHeight: 1.4 }}>{sel.label}</div>
                    <div style={{ fontSize: 10.5, color: "var(--t3)" }}>Read-only</div>
                  </div>
                  <span className="bdg bdg-wa" style={{ marginLeft: "auto" }}>Monitor mode</span>
                </div>
                <div className="msgs">
                  {chatMsgs.map(m => {
                    const sender = [...allUsers.teachers, ...allUsers.students].find(u => u.id === m.from);
                    const isTeacher = allUsers.teachers.some(t => t.id === m.from);
                    return (
                      <div key={m.id} className={`msg ${isTeacher ? "me" : "them"}`}>
                        <div className={`av ${isTeacher ? "av-t" : "av-s"}`} style={{ width: 24, height: 24, fontSize: 8, flexShrink: 0 }}>{sender?.initials || "?"}</div>
                        <div>
                          <div style={{ fontSize: 10, color: "var(--t4)", marginBottom: 2 }}>{sender?.name}</div>
                          <div className="bbl" style={{ background: isTeacher ? "var(--vi2)" : "var(--s3)", color: "var(--t1)" }}>{m.text}</div>
                          <div className="msg-t">{m.t}</div>
                        </div>
                      </div>
                    );
                  })}
                  <div ref={bot} />
                </div>
                <div style={{ padding: "10px 16px", background: "var(--wa2)", borderTop: "1px solid var(--wa)", fontSize: 12, color: "var(--wa)", display: "flex", alignItems: "center", gap: 6 }}>
                  {IC.info} Read-only monitoring mode — you cannot send messages here.
                </div>
              </>
            ) : (
              <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", color: "var(--t4)", fontSize: 13 }}>Select a conversation to monitor</div>
            )}
          </div>
        </div>
      </div>
    );
  }

  if (user.role === "admin") {
    return (
      <div className="chat-shell">
        <div className="chat-list" style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap", padding: "10px", borderBottom: "1px solid var(--b1)", background: "var(--s2)", flexShrink: 0 }}>
            <button className={`btn ${chatFilter==="all"?"btn-ac":"btn-gh"} btn-sm`} onClick={() => setChatFilter("all")}>All</button>
            <button className={`btn ${chatFilter==="coordinator"?"btn-ac":"btn-gh"} btn-sm`} onClick={() => setChatFilter("coordinator")}>Coordinators</button>
            <button className={`btn ${chatFilter==="teacher"?"btn-ac":"btn-gh"} btn-sm`} onClick={() => setChatFilter("teacher")}>Teachers</button>
            <button className={`btn ${chatFilter==="student"?"btn-ac":"btn-gh"} btn-sm`} onClick={() => setChatFilter("student")}>Students</button>
          </div>
          <div style={{ padding: "10px", borderBottom: "1px solid var(--b1)", background: "var(--s2)", flexShrink: 0 }}>
            <input 
              type="text" 
              placeholder="Search chat by name..." 
              value={chatSearch}
              onChange={e => setChatSearch(e.target.value)}
              style={{ width: "100%", padding:"6px 12px", borderRadius:6, border:"1px solid var(--b1)", background:"var(--bg)", color:"var(--t1)", fontSize:12 }}
            />
          </div>
          <div className="chat-contacts" style={{ flex: 1, overflowY: "auto", display: "block", paddingTop: "8px" }}>
            {(() => {
              let list = [];
              if (allUsers.coordinator && (chatFilter === "all" || chatFilter === "coordinator")) list.push(allUsers.coordinator);
              if (allUsers.coordinators) {
                 allUsers.coordinators.forEach(c => {
                   if (!list.find(u => u.id === c.id) && (chatFilter === "all" || chatFilter === "coordinator")) list.push(c);
                 });
              }
              if (chatFilter === "all" || chatFilter === "teacher") list.push(...(allUsers.teachers || []));
              if (chatFilter === "all" || chatFilter === "student") list.push(...(allUsers.students || []));
              
              if (chatSearch.trim()) {
                list = list.filter(u => u.name.toLowerCase().includes(chatSearch.toLowerCase()));
              }

              return list.map(c => {
                const k = getKey(user, c);
                return (
                  <div key={c.id} className={`cc ${sel?.id === c.id ? "sel" : ""}`} onClick={() => setSel(c)}>
                    <div className={`av ${avClass(c.role)}`} style={{ width: 30, height: 30, fontSize: 10, flexShrink: 0 }}>{c.initials}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="cc-name">{c.name}</div>
                      <div className="cc-sub">{c.role === "coordinator" ? "Coordinator" : c.role === "teacher" ? "Teacher" : c.grade}</div>
                    </div>
                    {(unreadCounts[k] || 0) > 0 && <div className="ni-dot">{unreadCounts[k]}</div>}
                  </div>
                );
              });
            })()}
          </div>
        </div>
        {sel && !sel.key ? (
          <div className="chat-body">
            <div className="chat-body-hd">
              <div className={`av ${avClass(sel.role)}`} style={{ width: 32, height: 32, fontSize: 10 }}>{sel.initials}</div>
              <div>
                <div style={{ fontWeight: 600, fontSize: 13, color: "var(--t1)" }}>{sel.name}</div>
                <div style={{ fontSize: 10.5, color: "var(--t3)", display: "flex", alignItems: "center", gap: 5 }}><span className="pulse" style={{ width: 5, height: 5 }} />Online</div>
              </div>
            </div>
            <div className="msgs">
              {chatMsgs.map(m => (
                <div key={m.id} className={`msg ${m.from === user.id ? "me" : "them"}`}>
                  <div className={`av ${m.from === user.id ? avClass(user.role) : avClass(sel.role)}`} style={{ width: 24, height: 24, fontSize: 8, flexShrink: 0 }}>
                    {m.from === user.id ? user.initials : sel.initials}
                  </div>
                  <div><div className="bbl">{m.text}</div><div className="msg-t">{m.t}</div></div>
                </div>
              ))}
              <div ref={bot} />
            </div>
            <div className="chat-inp-row">
              <textarea className="chat-inp" rows={1} placeholder="Type a message…" value={inp} onChange={e => setInp(e.target.value)} onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }} />
              <button className="send-btn" onClick={send}>{IC.send}</button>
            </div>
          </div>
        ) : (
          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", color: "var(--t4)", fontSize: 13 }}>Select a conversation</div>
        )}
      </div>
    );
  }

  return (
    <div className="chat-shell">
      <div className="chat-list" style={{ overflowY: "auto" }}>
        {user.role !== "student" && user.role !== "teacher" && allUsers.admins && allUsers.admins.length > 0 && (
          <>
            <div className="chat-list-hd" style={{ background: "var(--vi2)", color: "var(--vi)" }}>Admin Support</div>
            <div className="chat-contacts" style={{ flex: "none" }}>
              {allUsers.admins.map(a => {
                const k = getKey(user, a);
                const unread = unreadCounts[k] || 0;
                return (
                  <div key={a.id} className={`cc ${sel?.id === a.id ? "sel" : ""}`} onClick={() => setSel(a)}>
                    <div className="av av-c" style={{ width: 30, height: 30, fontSize: 10, background: "linear-gradient(135deg, #f59e0b, #f04545)" }}>{a.initials}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="cc-name">{a.name}</div>
                      <div className="cc-sub" style={{ fontSize: 9 }}>Portal issues · Password reset</div>
                    </div>
                    {unread > 0 && <div className="ni-dot">{unread}</div>}
                  </div>
                );
              })}
            </div>
          </>
        )}
        {user.role === "coordinator" && (
          <div style={{ display: "flex", gap: 3, padding: "8px 8px 4px", borderBottom: "1px solid var(--b1)" }}>
            <button onClick={() => setCoordView("own")} className="btn btn-ac btn-xs" style={{ flex: 1, justifyContent: "center" }}>My Chats</button>
            <button onClick={() => setCoordView("all")} className="btn btn-gh btn-xs" style={{ flex: 1, justifyContent: "center" }}>Monitor</button>
          </div>
        )}
        {user.role === "coordinator" && (
          <>
            <div className="chat-list-hd" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              Teachers
              <input type="text" placeholder="Search..." value={teacherSearch} onChange={e => setTeacherSearch(e.target.value)} style={{ padding: "4px", fontSize: "10px", width: "100px", borderRadius: "4px", border: "1px solid var(--b1)", background: "var(--bg)", color: "var(--t1)" }} />
            </div>
            <div className="chat-contacts" style={{ flex: 1, overflowY: "auto", maxHeight: "30vh" }}>
              {allUsers.teachers.filter(c => c.name.toLowerCase().includes(teacherSearch.toLowerCase())).map(c => {
                const k = getKey(user, c);
                const unread = unreadCounts[k] || 0;
                return (
                  <div key={c.id} className={`cc ${sel?.id === c.id ? "sel" : ""}`} onClick={() => setSel(c)}>
                    <div className="av av-t" style={{ width: 30, height: 30, fontSize: 10, flexShrink: 0 }}>{c.initials}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="cc-name">{c.name}</div>
                      <div className="cc-sub">Teacher</div>
                    </div>
                    {unread > 0 && <div className="ni-dot">{unread}</div>}
                  </div>
                );
              })}
            </div>
            <div className="chat-list-hd" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: "1px solid var(--b1)" }}>
              Students
              <input type="text" placeholder="Search..." value={studentSearch} onChange={e => setStudentSearch(e.target.value)} style={{ padding: "4px", fontSize: "10px", width: "100px", borderRadius: "4px", border: "1px solid var(--b1)", background: "var(--bg)", color: "var(--t1)" }} />
            </div>
            <div className="chat-contacts" style={{ flex: 1, overflowY: "auto", maxHeight: "30vh" }}>
              {allUsers.students.filter(c => c.name.toLowerCase().includes(studentSearch.toLowerCase())).map(c => {
                const k = getKey(user, c);
                const unread = unreadCounts[k] || 0;
                return (
                  <div key={c.id} className={`cc ${sel?.id === c.id ? "sel" : ""}`} onClick={() => setSel(c)}>
                    <div className="av av-s" style={{ width: 30, height: 30, fontSize: 10, flexShrink: 0 }}>{c.initials}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="cc-name">{c.name}</div>
                      <div className="cc-sub">{c.grade}</div>
                    </div>
                    {unread > 0 && <div className="ni-dot">{unread}</div>}
                  </div>
                );
              })}
            </div>
          </>
        )}
        {user.role === "teacher" && (
          <>
            <div className="chat-list-hd">Coordinator</div>
            <div className="chat-contacts" style={{ flex: "none", overflowY: "auto", maxHeight: "20vh" }}>
              {allUsers.coordinator && (
                <div className={`cc ${sel?.id === allUsers.coordinator.id ? "sel" : ""}`} onClick={() => setSel(allUsers.coordinator)}>
                  <div className="av av-c" style={{ width: 30, height: 30, fontSize: 10 }}>{allUsers.coordinator.initials}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="cc-name">{allUsers.coordinator.name}</div>
                    <div className="cc-sub">Coordinator</div>
                  </div>
                  {unreadCounts[getKey(user, allUsers.coordinator)] > 0 && <div className="ni-dot">{unreadCounts[getKey(user, allUsers.coordinator)]}</div>}
                </div>
              )}
            </div>
            <div className="chat-list-hd" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              My Students
              <input type="text" placeholder="Search..." value={studentSearch} onChange={e => setStudentSearch(e.target.value)} style={{ padding: "4px", fontSize: "10px", width: "100px", borderRadius: "4px", border: "1px solid var(--b1)", background: "var(--bg)", color: "var(--t1)" }} />
            </div>
            <div className="chat-contacts" style={{ flex: 1, overflowY: "auto", maxHeight: "30vh" }}>
              {allUsers.students.filter(s => user.students?.includes(s.id) && s.name.toLowerCase().includes(studentSearch.toLowerCase())).map(c => {
                const k = getKey(user, c);
                const unread = unreadCounts[k] || 0;
                return (
                  <div key={c.id} className={`cc ${sel?.id === c.id ? "sel" : ""}`} onClick={() => setSel(c)}>
                    <div className="av av-s" style={{ width: 30, height: 30, fontSize: 10 }}>{c.initials}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="cc-name">{c.name}</div>
                      <div className="cc-sub">{c.grade}</div>
                    </div>
                    {unread > 0 && <div className="ni-dot">{unread}</div>}
                  </div>
                );
              })}
              {allUsers.students.filter(s => user.students?.includes(s.id) && s.name.toLowerCase().includes(studentSearch.toLowerCase())).length === 0 && <div style={{ padding: 12, fontSize: 12, color: "var(--t4)" }}>No students found</div>}
            </div>
          </>
        )}
        {user.role === "student" && (
          <>
            <div className="chat-list-hd">Coordinator</div>
            <div className="chat-contacts" style={{ flex: "none", overflowY: "auto", maxHeight: "20vh" }}>
              {allUsers.coordinator && (
                <div className={`cc ${sel?.id === allUsers.coordinator.id ? "sel" : ""}`} onClick={() => setSel(allUsers.coordinator)}>
                  <div className="av av-c" style={{ width: 30, height: 30, fontSize: 10 }}>{allUsers.coordinator.initials}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="cc-name">{allUsers.coordinator.name}</div>
                    <div className="cc-sub">Coordinator</div>
                  </div>
                  {unreadCounts[getKey(user, allUsers.coordinator)] > 0 && <div className="ni-dot">{unreadCounts[getKey(user, allUsers.coordinator)]}</div>}
                </div>
              )}
            </div>
            <div className="chat-list-hd" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              My Teachers
              <input type="text" placeholder="Search..." value={teacherSearch} onChange={e => setTeacherSearch(e.target.value)} style={{ padding: "4px", fontSize: "10px", width: "100px", borderRadius: "4px", border: "1px solid var(--b1)", background: "var(--bg)", color: "var(--t1)" }} />
            </div>
            <div className="chat-contacts" style={{ flex: 1, overflowY: "auto", maxHeight: "30vh" }}>
              {allUsers.teachers.filter(t => user.teachers?.includes(t.id) && t.name.toLowerCase().includes(teacherSearch.toLowerCase())).map(c => {
                const k = getKey(user, c);
                const unread = unreadCounts[k] || 0;
                return (
                  <div key={c.id} className={`cc ${sel?.id === c.id ? "sel" : ""}`} onClick={() => setSel(c)}>
                    <div className="av av-t" style={{ width: 30, height: 30, fontSize: 10 }}>{c.initials}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="cc-name">{c.name}</div>
                    </div>
                    {unread > 0 && <div className="ni-dot">{unread}</div>}
                  </div>
                );
              })}
              {allUsers.teachers.filter(t => user.teachers?.includes(t.id)).length === 0 && <div style={{ padding: 12, fontSize: 12, color: "var(--t4)" }}>No teachers assigned</div>}
            </div>
          </>
        )}
      </div>
      {sel && !sel.key ? (
        <div className="chat-body">
          <div className="chat-body-hd">
            <div className={`av ${avClass(sel.role)}`} style={{ width: 32, height: 32, fontSize: 10 }}>{sel.initials}</div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 13, color: "var(--t1)" }}>{sel.name}</div>
              <div style={{ fontSize: 10.5, color: "var(--t3)", display: "flex", alignItems: "center", gap: 5 }}><span className="pulse" style={{ width: 5, height: 5 }} />Online</div>
            </div>
          </div>
          <div className="msgs">
            {chatMsgs.map(m => (
              <div key={m.id} className={`msg ${m.from === user.id ? "me" : "them"}`}>
                <div className={`av ${m.from === user.id ? avClass(user.role) : avClass(sel.role)}`} style={{ width: 24, height: 24, fontSize: 8, flexShrink: 0 }}>
                  {m.from === user.id ? user.initials : sel.initials}
                </div>
                <div><div className="bbl">{m.text}</div><div className="msg-t">{m.t}</div></div>
              </div>
            ))}
            <div ref={bot} />
          </div>
          <div className="chat-inp-row">
            <textarea className="chat-inp" rows={1} placeholder="Type a message…" value={inp} onChange={e => setInp(e.target.value)} onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }} />
            <button className="send-btn" onClick={send}>{IC.send}</button>
          </div>
        </div>
      ) : (
        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", color: "var(--t4)", fontSize: 13 }}>Select a conversation</div>
      )}
    </div>
  );
}

// ─── FILES ────────────────────────────────────────────────────────────────────
function FilesPage({ user, files, showToast, allUsers }) {
  const fr = useRef(null);
  const [am, setAm] = useState(false);
  const [pf, setPf] = useState(null);
  const [at, setAt] = useState([]);
  const [filterUser, setFilterUser] = useState("all");
  const myStudents = user.role==="teacher" ? allUsers.students.filter(s=>user.students?.includes(s.id)).sort((a,b)=>a.name.localeCompare(b.name)) : [];
  const myTeachers = user.role==="student" ? allUsers.teachers.filter(t=>user.teachers?.includes(t.id)).sort((a,b)=>a.name.localeCompare(b.name)) : [];

  const fmtFileDate = ts => {
    if (!ts) return "Uploaded: Just now";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return `Uploaded: ${d.toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"})}`;
  };

  const pick = async e => {
    const f=e.target.files[0]; if(!f)return;
    e.target.value="";
    try {
      const uploadRef = storageRef(storage, `files/${user.id}/${Date.now()}_${f.name}`);
      const snapshot = await uploadBytes(uploadRef, f);
      const downloadUrl = await getDownloadURL(snapshot.ref);
      const ext=f.name.split(".").pop().toLowerCase();
      const fo={name:f.name,size:f.size>1048576?`${(f.size/1048576).toFixed(1)} MB`:`${Math.round(f.size/1024)} KB`,uid:user.id,uname:user.name,to:[],type:["pdf"].includes(ext)?"pdf":"doc",downloadUrl,storagePath:snapshot.ref.fullPath};
      if(user.role==="teacher"&&myStudents.length>0){setPf(fo);setAt([]);setAm(true);}
      else if(user.role==="student"&&myTeachers.length>0){setPf(fo);setAt([]);setAm(true);}
      else{
        await addDoc(collection(db,"files"),{...fo,to:[user.id],createdAt:new Date()});
        showToast(`"${f.name}" uploaded!`);
      }
    } catch(err) {
      console.error("Upload error:", err);
      showToast("Upload failed: " + err.message);
    }
  };

  const confirmAssign = async () => {
    await addDoc(collection(db,"files"),{...pf,to:[...at,user.id],createdAt:new Date()});
    showToast(`Assigned to ${at.length} student(s)!`);
    setAm(false);
  };

  const deleteFile = async (file) => {
    if (!window.confirm("Delete this file? This cannot be undone.")) return;
    try {
      if (file.storagePath) {
        const fileRef = storageRef(storage, file.storagePath);
        await deleteObject(fileRef).catch(() => {});
      }
      await deleteDoc(doc(db, "files", file.id));
      showToast("File deleted");
    } catch (err) {
      showToast("Delete failed: " + err.message);
    }
  };

  const visible = files.filter(f => {
    if (user.role==="coordinator") return true;
    if (user.role==="teacher") return f.uid===user.id || f.to?.includes(user.id);
    return f.to?.includes(user.id) || f.uid===user.id;
  });
  const sortedFiles = [...visible].sort((a, b) => {
    const da = a.createdAt?.toDate ? a.createdAt.toDate().getTime() : (new Date(a.createdAt || 0)).getTime();
    const db = b.createdAt?.toDate ? b.createdAt.toDate().getTime() : (new Date(b.createdAt || 0)).getTime();
    return db - da; // Latest uploaded file at the top
  });

  const filteredFiles = sortedFiles.filter(f => {
    if (filterUser === "all") return true;
    return f.uid === filterUser || (f.to && f.to.includes(filterUser));
  });
  const tFiles = filteredFiles.filter(f=>allUsers.teachers.some(t=>t.id===f.uid));
  const sFiles = filteredFiles.filter(f=>allUsers.students.some(s=>s.id===f.uid));

  const FRow = ({f}) => (
    <div className="frow">
      <div className={`ficon ${f.type==="pdf"?"fi-pdf":"fi-doc"}`}>{f.type.toUpperCase()}</div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:13,fontWeight:500,color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.name}</div>
        <div style={{fontSize:11,color:"var(--t3)",marginTop:2}}>
          {f.size} · {f.uname} · {fmtFileDate(f.createdAt)}
          {user.role==="teacher"&&f.to?.length>0&&<> · {f.to.filter(id=>id!==user.id).map(id=>allUsers.students.find(s=>s.id===id)?.name.split(" ")[0]).filter(Boolean).join(", ")}</>}
        </div>
      </div>
      <button className="btn btn-gh btn-sm" onClick={()=>{ if(f.downloadUrl) window.open(f.downloadUrl,"_blank"); else showToast("Download not available for this file"); }}>Download</button>
      {(user.id === f.uid || user.role === "coordinator") && (
        <button className="btn btn-er btn-sm" onClick={() => deleteFile(f)}>
          {IC.trash}
        </button>
      )}
    </div>
  );

  return (
    <div className="vcol">
      {user.role !== "coordinator" && (
        <>
          <input type="file" ref={fr} style={{display:"none"}} onChange={pick} />
          <div className="dz" onClick={()=>fr.current.click()}>
            <div style={{fontSize:28,marginBottom:8}}>📎</div>
            <div style={{fontSize:13.5,fontWeight:500,color:"var(--t1)"}}>Click to upload a file</div>
            <div style={{fontSize:12,color:"var(--t3)",marginTop:4}}>{user.role==="teacher"?"You can assign files to your specific students":"Share materials with your teacher"}</div>
          </div>
        </>
      )}
      {user.role === "teacher" && (
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 11, fontWeight: 600, color: "var(--t3)", marginRight: 8 }}>Filter by student:</label>
          <select
            value={filterUser}
            onChange={e => setFilterUser(e.target.value)}
            style={{ padding: "6px 12px", background: "var(--s2)", border: "1px solid var(--b1)", borderRadius: 8, color: "var(--t1)", fontSize: 12 }}
          >
            <option value="all">All Students</option>
            {allUsers.students.filter(s => user.students?.includes(s.id)).map(s => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>
      )}
      {user.role === "student" && (
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 11, fontWeight: 600, color: "var(--t3)", marginRight: 8 }}>Filter by teacher:</label>
          <select
            value={filterUser}
            onChange={e => setFilterUser(e.target.value)}
            style={{ padding: "6px 12px", background: "var(--s2)", border: "1px solid var(--b1)", borderRadius: 8, color: "var(--t1)", fontSize: 12 }}
          >
            <option value="all">All Teachers</option>
            {allUsers.teachers.filter(t => user.teachers?.includes(t.id)).map(t => (
              <option key={t.id} value={t.id}>{t.name}</option>
            ))}
          </select>
        </div>
      )}
      {user.role === "coordinator" && (
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 11, fontWeight: 600, color: "var(--t3)", marginRight: 8 }}>Filter by user:</label>
          <select
            value={filterUser}
            onChange={e => setFilterUser(e.target.value)}
            style={{ padding: "6px 12px", background: "var(--s2)", border: "1px solid var(--b1)", borderRadius: 8, color: "var(--t1)", fontSize: 12 }}
          >
            <option value="all">All Users</option>
            <optgroup label="Teachers">
              {allUsers.teachers.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
            </optgroup>
            <optgroup label="Students">
              {allUsers.students.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </optgroup>
          </select>
        </div>
      )}
      <div className="card">
        <div className="card-title" style={{marginBottom:12}}>{IC.file} {user.role==="student"?"Materials from your teachers":"Teacher files"}</div>
        {tFiles.length===0 && <div className="empty"><div className="empty-icon">📂</div>No files yet</div>}
        {tFiles.map(f=><FRow key={f.id} f={f}/>)}
      </div>
      <div className="card">
        <div className="card-title" style={{marginBottom:12}}>{IC.up} {user.role==="student"?"Your uploads":"Student submissions"}</div>
        {sFiles.length===0 && <div className="empty"><div className="empty-icon">📤</div>No files yet</div>}
        {sFiles.map(f=><FRow key={f.id} f={f}/>)}
      </div>
      {am&&pf&&(
        <div className="ovl" onClick={e=>e.target===e.currentTarget&&setAm(false)}>
          <div className="mdl">
            <div className="mdl-title">{IC.up} Assign file to {user.role==="student" ? "teachers" : "students"}</div>
            <div style={{fontSize:13,color:"var(--t2)",marginBottom:16}}>"{pf.name}" — select who can see this:</div>
            <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:18,maxHeight:"40vh",overflowY:"auto",paddingRight:"4px"}}>
              {(user.role==="student" ? myTeachers : myStudents).map(s=>(
                <label key={s.id} style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",padding:"10px 13px",borderRadius:10,background:"var(--s2)",border:`1.5px solid ${at.includes(s.id)?"var(--ac)":"var(--b1)"}`}}>
                  <input type="checkbox" checked={at.includes(s.id)} onChange={()=>setAt(p=>p.includes(s.id)?p.filter(x=>x!==s.id):[...p,s.id])} />
                  <div className={`av ${user.role==="student"?"av-t":"av-s"}`} style={{width:26,height:26,fontSize:9}}>{s.initials}</div>
                  <div style={{fontSize:13,fontWeight:500,color:"var(--t1)"}}>{s.name} · {user.role==="student"?s.subject:s.grade}</div>
                </label>
              ))}
            </div>
            <div className="dp" style={{justifyContent:"flex-end",gap:8}}>
              <button className="btn btn-gh" onClick={()=>setAm(false)}>Cancel</button>
              <button className="btn btn-ac" onClick={confirmAssign} disabled={at.length===0}>Assign to {at.length} {user.role==="student"?"teacher":"student"}{at.length!==1?"s":""} →</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── ATTENDANCE ───────────────────────────────────────────────────────────────
function AttendancePage({ user, classes, showToast, allUsers }) {
  const mc = user.role==="coordinator" ? classes
    : user.role==="teacher" ? classes.filter(c=>c.tId===user.id)
    : classes.filter(c=>c.sIds?.includes(user.id));
  const done=mc.filter(c=>c.done),pct=mc.length?Math.round(done.length/mc.length*100):0;
  const pend=mc.filter(c=>!c.done&&clsStatus(c)==="mark"&&(
    (user.role==="teacher"&&!c.teacherDone)||(user.role==="student"&&!c.studentDone)
  ));
  const mark = async id => {
    const cls = classes.find(c => c.id === id);
    if (!cls) return;
    const updates = {};
    if (user.role === "teacher") {
      updates.teacherDone = true;
      if (cls.studentDone) { updates.done = true; updates.ts = new Date().toISOString(); }
    } else if (user.role === "student") {
      updates.studentDone = true;
      if (cls.teacherDone) { updates.done = true; updates.ts = new Date().toISOString(); }
    }
    await updateDoc(doc(db, "classes", id), updates);
    showToast("Class marked done!");
  };
  return (
    <div className="vcol">
      <div className="grid3">
        <div className="stile em"><div className="st-lbl">Completed</div><div className="st-val">{done.length}</div></div>
        <div className="stile ac"><div className="st-lbl">Total</div><div className="st-val">{mc.length}</div></div>
        <div className="stile wa"><div className="st-lbl">Attendance %</div><div className="st-val">{pct}%</div></div>
      </div>
      {(user.role==="teacher"||user.role==="student")&&pend.length>0&&(
        <div className="card" style={{borderColor:"var(--wa)"}}>
          <div className="card-title" style={{marginBottom:12}}>⏳ Pending confirmation</div>
          {pend.map(c=>(
            <div key={c.id} className="crow mark">
              <div className="cind i-wa"/>
              <div className="cr-info"><div className="cr-name">{c.title}</div><div className="cr-meta">{fmtDate(c.date)} · <TimeDisplay c={c} user={user} allUsers={allUsers} /></div></div>
              <button className="btn btn-wa" onClick={()=>mark(c.id)}>{IC.check} Mark done</button>
            </div>
          ))}
        </div>
      )}
      <div className="card">
        <div className="card-title" style={{marginBottom:14}}>{IC.att} Attendance register</div>
        {done.length===0 && <div className="empty"><div className="empty-icon">📋</div>No completed classes</div>}
        {done.map((c,i)=>{const t=allUsers.teachers.find(x=>x.id===c.tId);return(
          <div key={c.id} className="att-row">
            <div className="att-num">{i+1}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:500,color:"var(--t1)"}}>{c.title}</div>
              <div style={{fontSize:11,color:"var(--t3)",marginTop:2}}>{fmtDate(c.date)} · <TimeDisplay c={c} user={user} allUsers={allUsers} /> · {c.dur} min{user.role==="coordinator"&&t&&<> · {t.name}</>}</div>
            </div>
            <div style={{textAlign:"right"}}>
              <span className="bdg bdg-em">{IC.check} Done</span>
              {c.ts&&<div style={{fontSize:10,color:"var(--t4)",marginTop:3}}>{new Date(c.ts).toLocaleTimeString("en-IN",{hour:"2-digit",minute:"2-digit"})}</div>}
            </div>
          </div>
        );})}
      </div>
    </div>
  );
}

// ─── PEOPLE ───────────────────────────────────────────────────────────────────
function PeoplePage({ user, which, allUsers }) {
  const [search, setSearch] = useState("");
  const isStu = which==="students";
  let list = isStu
    ? (user.role==="coordinator" ? allUsers.students : allUsers.students.filter(s=>user.students?.includes(s.id)))
    : (user.role==="coordinator" ? allUsers.teachers : allUsers.teachers.filter(t=>user.teachers?.includes(t.id)));
  list.sort((a,b) => (a.name||"").localeCompare(b.name||""));

  if (search.trim()) {
    const term = search.toLowerCase();
    list = list.filter(p => p.name?.toLowerCase().includes(term));
  }

  return (
    <div className="vcol">
      <div className="card">
        <div className="card-title" style={{marginBottom:14, display:"flex", justifyContent:"space-between", alignItems:"center"}}>
          <span>{IC.people} {isStu?"Students":"Teachers"} ({list.length})</span>
          <input
            type="text"
            placeholder={`Search ${isStu ? "students" : "teachers"}...`}
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{padding:"6px 12px", borderRadius:6, border:"1px solid var(--b1)", background:"var(--s2)", color:"var(--t1)", fontSize:13, width: 220}}
          />
        </div>
        {list.length===0 && <div className="empty"><div className="empty-icon">👤</div>None assigned to you</div>}
        <div style={{ maxHeight: "70vh", overflowY: "auto", paddingRight: 4 }}>
          {list.map(p=>{
          const rel = isStu
            ? allUsers.teachers.filter(t=>p.teachers?.includes(t.id))
            : (user.role==="student" ? [] : allUsers.students.filter(s=>p.students?.includes(s.id)));
          return (
            <div key={p.id} className="pcard">
              <div className={`av ${isStu?"av-s":"av-t"}`} style={{width:42,height:42,fontSize:13,borderRadius:11}}>{p.initials}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontFamily:"var(--fs)",fontSize:17,color:"var(--t1)"}}>{p.name}</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:4,margin:"5px 0"}}>
                  <span className="bdg bdg-ac">{isStu?p.grade:p.subject}</span>
                  <span className="bdg bdg-cy">{p.tzL}</span>
                </div>
                {!(user.role === "student" && !isStu) && (
                  <div className="prow">{IC.loc} {p.location}</div>
                )}
                {(user.role === "coordinator" || user.role === "admin") && <>
                  <div className="prow">{IC.mail} {p.email}</div>
                  <div className="prow">{IC.phone} {p.phone}</div>
                </>}
                {isStu && allUsers?.coordinator && (
                  <div className="prow">{IC.people} Coordinator: {allUsers.coordinator.name}</div>
                )}
                {!(user.role === "teacher" && isStu) && (
                  <div style={{marginTop:7,display:"flex",flexWrap:"wrap"}}>
                    {rel.map(r=><span key={r.id} className="chip">{r.name}{isStu?` · ${r.subject}`:` · ${r.grade}`}</span>)}
                  </div>
                )}
              </div>
            </div>
          );
        })}
        </div>
      </div>
    </div>
  );
}

// ─── SUPPORT ──────────────────────────────────────────────────────────────────
function SupportPage({ user, tickets, showToast, allUsers }) {
  const [sm, setSm] = useState(false); const [rm, setRm] = useState(null);
  const [fm, setFm] = useState({subj:"",msg:""}); const [rt, setRt] = useState("");
  const isAdmin = user.role==="admin";
  const isCoord = user.role==="coordinator";
  // Admin sees all tickets; others see only their own
  const mine = isAdmin ? tickets : tickets.filter(t=>t.from===user.id);
  const fmtTicketTime = ts => {
    if (!ts) return "Just now";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    const now = new Date(); now.setHours(0,0,0,0);
    const diff = Math.round((new Date(d.toDateString()) - now) / 86400000);
    const timeStr = d.toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit",hour12:true});
    if (diff===0) return `Today ${timeStr}`;
    if (diff===-1) return `Yesterday ${timeStr}`;
    return d.toLocaleDateString("en-IN",{month:"short",day:"numeric"}) + " " + timeStr;
  };
  const sub = async () => {
    if (!fm.subj||!fm.msg) return;
    await addDoc(collection(db, "tickets"), {
      from: user.id, fname: user.name, frole: user.role,
      subj: fm.subj, msg: fm.msg, status: "open", reply: "", createdAt: new Date(),
      history: [{ text: fm.msg, sender: user.role, senderName: user.name, ts: Date.now() }]
    });
    showToast("Ticket submitted!"); setSm(false); setFm({subj:"",msg:""});
  };
  const reply = async (markResolved) => {
    if (!markResolved && !rt.trim()) return;
    const updateData = { status: markResolved ? "resolved" : "open" };
    let newHistory = rm.history || [
      { text: rm.msg, sender: rm.frole, senderName: rm.fname, ts: rm.createdAt?.toMillis?.() || Date.now() },
      ...(rm.reply ? [{ text: rm.reply, sender: "admin", senderName: "Admin", ts: rm.createdAt?.toMillis?.() || Date.now() }] : [])
    ];
    if (rt.trim()) {
      newHistory.push({ text: rt, sender: user.role, senderName: user.name, ts: Date.now() });
      updateData.reply = rt; // keeping for backward compatibility
      updateData.history = newHistory;
    }
    await updateDoc(doc(db, "tickets", rm.id), updateData);
    showToast(markResolved ? "Ticket resolved!" : "Reply sent!"); 
    setRm(null); setRt("");
  };
  const delTicket = async (id) => {
    await deleteDoc(doc(db, "tickets", id));
    showToast("Ticket deleted.");
  };
  return (
    <div className="vcol">
      {/* Users (Teacher/Student/Coordinator): show admin contact card + create ticket button */}
      {!isAdmin&&(
        <div className="card" style={{borderColor:"var(--ac)",background:"var(--ac3)"}}>
          <div className="card-title" style={{marginBottom:12}}>{IC.help} Help Desk</div>
          <div style={{display:"flex",gap:13,alignItems:"center",padding:"14px",background:"var(--s1)",borderRadius:12,marginBottom:14,border:"1px solid var(--b1)"}}>
            <div className="av av-c" style={{width:44,height:44,fontSize:15}}>{allUsers.admins?.[0]?.initials || "A"}</div>
            <div>
              <div style={{fontFamily:"var(--fs)",fontSize:17,color:"var(--t1)"}}>{allUsers.admins?.[0]?.name || "Admin"}</div>
              <div style={{fontSize:11.5,color:"var(--t3)",marginTop:3}}>Administrator</div>
            </div>
          </div>
          <button className="btn btn-ac" onClick={()=>setSm(true)}>{IC.plus} Raise a support ticket</button>
        </div>
      )}
      {/* Admin: stats only */}
      {isAdmin&&(
        <div className="grid3">
          <div className="stile ac"><div className="st-lbl">Total tickets</div><div className="st-val">{tickets.length}</div></div>
          <div className="stile wa"><div className="st-lbl">Open</div><div className="st-val">{tickets.filter(t=>t.status==="open").length}</div></div>
          <div className="stile em"><div className="st-lbl">Resolved</div><div className="st-val">{tickets.filter(t=>t.status==="resolved").length}</div></div>
        </div>
      )}
      <div className="card">
        <div className="card-title" style={{marginBottom:14}}>{isAdmin?"All support tickets":"Your tickets"}</div>
        {mine.length===0&&<div className="empty"><div className="empty-icon">🎫</div>No tickets yet</div>}
        {mine.map(t=>(
          <div key={t.id} className={`tkt ${t.status}`} style={{ cursor: "pointer" }} onClick={() => { setRm(t); setRt(""); }}>
            <div className="db"><div style={{fontWeight:600,fontSize:13.5,color:"var(--t1)"}}>{t.subj}</div><span className={`bdg ${t.status==="open"?"bdg-wa":"bdg-em"}`}>{t.status}</span></div>
            <div style={{fontSize:11,color:"var(--t3)",marginTop:3}}>{t.fname} · {t.frole} · {fmtTicketTime(t.createdAt)}</div>
            <div style={{fontSize:13,color:"var(--t2)",marginTop:8,lineHeight:1.6}}>{t.msg}</div>
            <div style={{display:"flex",gap:8,marginTop:9,alignItems:"center"}}>
              {t.status==="open"&&<span style={{ fontSize: 12, color: "var(--cy)", fontWeight: 500 }}>{IC.reply} View or reply to ticket</span>}
              {isAdmin&&t.status==="resolved"&&<button className="btn btn-er btn-sm" onClick={(e)=>{e.stopPropagation(); delTicket(t.id);}}>{IC.trash} Delete</button>}
            </div>
          </div>
        ))}
      </div>
      {sm&&<div className="ovl" onClick={e=>e.target===e.currentTarget&&setSm(false)}><div className="mdl"><div className="mdl-title">{IC.help} Raise a support ticket</div><div className="fld"><label>Subject</label><input placeholder="e.g. Schedule conflict next Tuesday" value={fm.subj} onChange={e=>setFm(f=>({...f,subj:e.target.value}))}/></div><div className="fld"><label>Message</label><textarea value={fm.msg} placeholder="Describe your issue in detail…" onChange={e=>setFm(f=>({...f,msg:e.target.value}))}/></div><div className="dp" style={{justifyContent:"flex-end",gap:8,marginTop:16}}><button className="btn btn-gh" onClick={()=>setSm(false)}>Cancel</button><button className="btn btn-ac" onClick={sub}>Submit ticket →</button></div></div></div>}
      {rm && (
        <div className="ovl" onClick={e => e.target === e.currentTarget && setRm(null)}>
          <div className="mdl" style={{ maxWidth: 500, width: "90%" }}>
            <div className="mdl-title">{IC.help} {rm.subj}</div>
            <div style={{ maxHeight: "50vh", overflowY: "auto", display: "flex", flexDirection: "column", gap: 10, padding: "14px", background: "var(--s1)", borderRadius: 8, marginBottom: 15, border: "1px solid var(--b1)" }}>
              {(() => {
                const h = rm.history || [
                  { text: rm.msg, sender: rm.frole, senderName: rm.fname, ts: rm.createdAt?.toMillis?.() || Date.now() },
                  ...(rm.reply ? [{ text: rm.reply, sender: "admin", senderName: "Admin", ts: rm.createdAt?.toMillis?.() || Date.now() }] : [])
                ];
                return h.map((m, i) => (
                  <div key={i} style={{ alignSelf: m.sender === user.role ? "flex-end" : "flex-start", background: m.sender === user.role ? "var(--ac)" : "var(--s2)", color: m.sender === user.role ? "#fff" : "var(--t1)", padding: "10px 14px", borderRadius: 12, maxWidth: "85%", fontSize: 13, lineHeight: 1.5 }}>
                    <div style={{ fontSize: 10.5, opacity: 0.8, marginBottom: 4, fontWeight: 500 }}>{m.senderName}</div>
                    <div style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{m.text}</div>
                  </div>
                ));
              })()}
            </div>
            {rm.status === "open" && (
              <div className="fld" style={{ marginBottom: 0 }}>
                <textarea value={rt} onChange={e => setRt(e.target.value)} placeholder="Type your response…" style={{ minHeight: 80 }} />
              </div>
            )}
            <div className="dp" style={{ justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
              <button className="btn btn-gh" onClick={() => setRm(null)}>Cancel</button>
              {rm.status === "open" && (
                <>
                  <button className="btn btn-ac" onClick={() => reply(false)}>{IC.reply} Send</button>
                  {isAdmin && <button className="btn btn-em" onClick={() => reply(true)}>{IC.check} Mark as resolved</button>}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── GUIDELINES ───────────────────────────────────────────────────────────────
function GuidelinesPage({ user }) {
  const [tab, setTab] = useState("overview");
  const [openFaq, setOpenFaq] = useState(null);

  const FAQ = ({ q, a, id }) => (
    <div className="guide-faq">
      <div className="faq-q" onClick={()=>setOpenFaq(openFaq===id?null:id)}>
        <span>{q}</span>
        <span style={{transform:openFaq===id?"rotate(180deg)":"none",transition:"transform .2s",flexShrink:0}}>{IC.chev}</span>
      </div>
      {openFaq===id && <div className="faq-a">{a}</div>}
    </div>
  );

  const Step = ({ num, title, desc }) => (
    <div className="guide-step">
      <div className="gs-num">{num}</div>
      <div className="gs-body"><div className="gs-title">{title}</div><div className="gs-desc">{desc}</div></div>
    </div>
  );

  const teacherGuide = (
    <div className="vcol">
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.cal} Managing your classes</div>
        <div style={{background:"var(--wa2)",border:"1px solid var(--wa)",borderRadius:8,padding:"10px 14px",fontSize:12.5,color:"var(--wa)",marginBottom:14}}>⚠️ Only your Coordinator can schedule, edit, or delete classes. If you need a change, use the Support tab.</div>
        <Step num="1" title="View your schedule" desc="Click 'My Classes' in the sidebar. You'll see all upcoming and completed classes assigned to you by the Coordinator." />
        <Step num="2" title="Join a class" desc="A green 'Join Meet' button appears on the day of the class. Click it to open Google Meet in a new tab. The button is disabled until then." />
        <Step num="3" title="Mark class as done" desc="After a class ends, an orange 'Mark done' button appears. Click it to confirm attendance and update the attendance register." />
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.people} Your students</div>
        <Step num="1" title="View assigned students only" desc="The 'My Students' tab shows only the students assigned to you by the Coordinator — not all students on the platform." />
        <Step num="2" title="Chat with students" desc="Use the Chat tab to message your students. You can only message students who are assigned to you." />
        <Step num="3" title="Share files" desc="Upload materials in the Files tab and assign them to specific students. Students will only see files you've explicitly shared with them." />
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.clock} Join link timing — important!</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:12}}>
          <span className="info-pill ip-gy">Before class day: Link disabled</span>
          <span className="info-pill ip-ac">On class day: Link activates ✓</span>
          <span className="info-pill ip-em">During class: Link is active ✓</span>
          <span className="info-pill ip-wa">After class: Mark done appears</span>
        </div>
        <p style={{fontSize:12.5,color:"var(--t2)",lineHeight:1.65}}>The join link opens on the day of the scheduled time and remains active until the class duration ends. If you join late, the link may already be closed.</p>
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.help} FAQs for teachers</div>
        <FAQ id="f1" q="I can't find the 'Schedule a class' button. Where is it?" a="Class scheduling is handled exclusively by your Coordinator. This ensures no conflicts in the schedule. To request a new class or reschedule, use the 'Contact Coordinator' tab and raise a support ticket." />
        <FAQ id="f2" q="How do I change my timezone?" a="Reach out to your Coordinator. They have the admin tools to adjust your timezone settings." />
        <FAQ id="f3" q="The Join Meet button is greyed out. Why?" a="The button activates on the day of the class. If it's still greyed out on the class day, refresh the page or contact your Coordinator." />
        <FAQ id="f4" q="Can I see files uploaded by other teachers?" a="No. You can only see files you uploaded yourself, or files that students have shared with you. Files from other teachers are not visible to you." />
      </div>
    </div>
  );

  const studentGuide = (
    <div className="vcol">
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.cal} Joining your classes</div>
        <Step num="1" title="Check your dashboard" desc="Your next upcoming class will be highlighted at the top of your dashboard." />
        <Step num="2" title="Wait for the join link" desc="The 'Join Meet' button activates on the day of the class. You cannot join earlier. Set a reminder for 5–10 minutes before class." />
        <Step num="3" title="Join on time" desc="Click the button to enter Google Meet. If the teacher hasn't arrived, wait patiently." />
        <Step num="4" title="After class" desc="Your teacher will mark the class as done. This updates your attendance record automatically. You can view your attendance history in the Attendance tab." />
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.people} Your teachers</div>
        <Step num="1" title="View your assigned teachers" desc="The 'My Teachers' tab shows only the teachers assigned to you — each for a different subject. You won't see teachers who aren't teaching you." />
        <Step num="2" title="Chat with your teacher" desc="Use the Chat tab to message any of your assigned teachers. You can ask questions, share updates, or discuss upcoming classwork." />
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.file} Files & materials</div>
        <Step num="1" title="Access teacher materials" desc="Your teachers upload notes, worksheets, and other materials for you. You'll see them in the Files tab under 'Materials from your teachers'." />
        <Step num="2" title="Submit your work" desc="You can upload your solutions or assignments from the Files tab. Your teacher will see them under 'Student submissions'." />
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.clock} Class join timing</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:12}}>
          <span className="info-pill ip-gy">Before class day: Disabled 🔒</span>
          <span className="info-pill ip-ac">On class day: Button turns green ✓</span>
          <span className="info-pill ip-em">Class time: Join active ✓</span>
          <span className="info-pill ip-wa">After class ends: Closed</span>
        </div>
        <p style={{fontSize:12.5,color:"var(--t2)",lineHeight:1.65}}>Plan to click the join button on the day of the class. The class may be marked late if you join after the scheduled start time. Contact your Coordinator if there's a technical issue.</p>
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.help} FAQs for students</div>
        <FAQ id="s1" q="I want to change my class time. What should I do?" a="Students cannot reschedule classes directly. Go to 'Contact Coordinator', raise a support ticket explaining the conflict, and your Coordinator will work with the teacher to find a new time." />
        <FAQ id="s2" q="I can't see my teacher in the Chat or My Teachers tab." a="You can only see teachers who have been assigned to you by the Coordinator. If a teacher is missing, contact your Coordinator." />
        <FAQ id="s3" q="My Join Meet button isn't showing up even though it's class time." a="Try refreshing the page. The button checks the time live. If it's still not showing after a refresh, contact your Coordinator immediately via the Support tab." />
        <FAQ id="s4" q="Can I see what files other students have uploaded?" a="No — you can only see files your teachers have shared with you specifically, and your own uploads. Privacy is maintained across all students." />
        <FAQ id="s5" q="How is attendance tracked?" a="Your teacher marks the class as done after each session. This is recorded with a timestamp in the attendance register. You can view your full history in the Attendance tab." />
      </div>
    </div>
  );

  const coordGuide = (
    <div className="vcol">
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.cal} Scheduling classes</div>
        <Step num="1" title="Open Manage Schedule" desc="Click 'Manage Schedule' in the sidebar. Use the calendar to navigate to the desired date and click 'Schedule new class'." />
        <Step num="2" title="Assign teacher and students" desc="Select the teacher from the dropdown. Only students assigned to that teacher will appear for selection. Choose one or more students." />
        <Step num="3" title="Set recurring classes" desc="Check 'Repeat weekly' and select the number of weeks (1–10). This schedules the class on the same day and time for the selected number of consecutive weeks." />
        <Step num="4" title="Edit or delete" desc="Use the pencil icon to reschedule any class, or the trash icon to delete it. You can manage all classes from the full list on the right panel." />
      </div>
    </div>
  );

  const adminGuide = (
    <div className="vcol">
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.people} User Management</div>
        <Step num="1" title="Create users" desc="Go to 'Manage Users' and click 'Add User'. Fill in name, email, role, timezone, and subject/grade as applicable. A temporary password is auto-generated and shown once — copy and share it securely with the user." />
        <Step num="2" title="Edit user details" desc="Click the pencil icon next to any user to update their name, email, phone, location, timezone, subject, or grade. Changes take effect immediately." />
        <Step num="3" title="Reset passwords" desc="Use the key icon on any user card to set a new password for that account. Useful when a user forgets their login credentials." />
        <Step num="4" title="Delete users" desc="Use the trash icon to permanently remove a user from the platform. This deletes both their Firebase Auth account and their Firestore profile. This action cannot be undone." />
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.rep} Users Mapping</div>
        <Step num="1" title="Select a coordinator" desc="In 'Users Mapping', choose a coordinator from the list. Their current teacher assignments are shown." />
        <Step num="2" title="Assign teachers to coordinator" desc="Check the teachers you want under this coordinator and click 'Save teacher assignments'. Each teacher can only be assigned to one coordinator." />
        <Step num="3" title="Assign students to teachers" desc="Select a teacher to see their current student assignments. Check students and click 'Save student assignments'. Students can be assigned to multiple teachers." />
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">🏗️ Hierarchy overview</div>
        <div style={{background:"var(--wa2)",border:"1px solid var(--wa)",borderRadius:8,padding:"10px 14px",fontSize:12.5,color:"var(--wa)",marginBottom:14}}>⚠️ The platform follows a strict 3-level hierarchy: Admin → Coordinator → Teachers → Students. Coordinators only see users under their own hierarchy.</div>
        <Step num="1" title="Admin" desc="Full platform access. Manages all users, mappings, and settings. Not visible to teachers or students." />
        <Step num="2" title="Coordinator" desc="Sees and manages only the teachers and students assigned to them. Schedules classes, handles support tickets, manages files." />
        <Step num="3" title="Teachers & Students" desc="Only see people directly assigned to them. Teachers see their own students; students see their own teachers." />
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.chat} Messages</div>
        <Step num="1" title="Platform-wide visibility" desc="As admin, you can view all message conversations on the platform in the Messages tab." />
        <Step num="2" title="Support tickets" desc="All support tickets raised by teachers and students appear in your Support tab. Reply and resolve tickets to help users." />
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">🔒 Security</div>
        <Step num="1" title="Temporary passwords" desc="All created users get a temporary password. Remind them to change it on first login via Profile → Change Password." />
        <Step num="2" title="Role enforcement" desc="All role restrictions are enforced server-side via Firebase. Frontend UI restrictions are for convenience only — do not rely on them for security." />
        <Step num="3" title="Token-based auth" desc="User management operations (create, update, delete) use Firebase ID tokens verified server-side in Cloud Functions. Tokens expire hourly and are auto-refreshed." />
      </div>
      <div className="guide-sec">
        <div className="guide-sec-title">{IC.help} Admin FAQs</div>
        <FAQ id="a1" q="Can I have more than one coordinator?" a="Yes — the platform supports multiple coordinators. Each coordinator has their own set of assigned teachers and students managed via Users Mapping." />
        <FAQ id="a2" q="What happens if I delete a coordinator?" a="Their Firebase Auth account and Firestore profile are deleted. Their assigned teachers and students retain their coordinatorId field but will appear unassigned in Users Mapping." />
        <FAQ id="a3" q="Can a teacher be assigned to multiple coordinators?" a="No — each teacher has a single coordinatorId. Reassigning a teacher to a new coordinator removes them from the previous one." />
        <FAQ id="a4" q="Where are Google Calendar credentials stored?" a="In Firestore under config/google_calendar. The setup flow uses OAuth2 and stores the refresh token there. Use 'Connect Google Calendar' in Settings to re-authorize if needed." />
      </div>
    </div>
  );

  const tabs = [
    { id:"overview", l:"Overview" },
    { id:"howto", l:user.role==="admin"?"Admin guide":user.role==="coordinator"?"Coordinator guide":user.role==="teacher"?"Teacher guide":"Student guide" },
    { id:"faqs", l:"FAQs" },
  ];

  return (
    <div className="vcol">
      <div className="guide-hero">
        <div className="guide-hero-title">Welcome to <em>Vidvana Sphere</em></div>
        <div className="guide-hero-sub">
          {user.role==="admin" && "As Administrator, you have full control over the entire platform — user creation, role assignments, hierarchy mapping, and system configuration."}
          {user.role==="coordinator" && "As Coordinator, you have full control over scheduling, people management, files, and support. Here's everything you need to know."}
          {user.role==="teacher" && `Hi ${user.name.split(" ").pop()}! Here's your complete guide to teaching on Vidvana Sphere — from joining classes to sharing files with your students.`}
          {user.role==="student" && `Hi ${user.name.split(" ")[0]}! This guide explains how to join your classes, chat with teachers, access materials, and get help when you need it.`}
        </div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:14}}>
          {user.role==="admin"&&<><span className="info-pill ip-ac">👤 Manage users</span><span className="info-pill ip-em">🏗️ Map hierarchy</span><span className="info-pill ip-vi">🎫 Support tickets</span><span className="info-pill ip-cy">🔒 Platform security</span></>}
          {user.role==="teacher"&&<><span className="info-pill ip-ac">📅 View your schedule</span><span className="info-pill ip-em">🎥 Join classes</span><span className="info-pill ip-vi">💬 Chat with students</span><span className="info-pill ip-cy">📂 Share files</span></>}
          {user.role==="student"&&<><span className="info-pill ip-ac">📅 See your classes</span><span className="info-pill ip-em">🎥 Join via Meet</span><span className="info-pill ip-vi">💬 Chat with teachers</span><span className="info-pill ip-cy">📂 Access materials</span></>}
          {user.role==="coordinator"&&<><span className="info-pill ip-ac">📅 Schedule classes</span><span className="info-pill ip-em">👥 Manage people</span><span className="info-pill ip-vi">🎫 Handle support</span><span className="info-pill ip-cy">📂 All files</span></>}
        </div>
      </div>

      <div className="tlbar">
        {tabs.map(t=><div key={t.id} className={`tltab ${tab===t.id?"on":""}`} onClick={()=>setTab(t.id)}>{t.l}</div>)}
      </div>

      {tab==="overview" && (
        <div className="vcol">
          <div className="guide-sec">
            <div className="guide-sec-title">🏗️ How Vidvana Sphere works</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              {[
                {icon:"⚙️",role:"Coordinator",desc:"Schedules all classes, assigns teachers to students, manages files, and resolves support tickets."},
                {icon:"👨‍🏫",role:"Teacher",desc:"Joins scheduled classes, communicates with assigned students, shares study materials, marks attendance."},
                {icon:"🎓",role:"Student",desc:"Joins classes, chats with assigned teachers, downloads materials, submits work, tracks attendance."},
                {icon:"🎥",role:"Google Meet",desc:"Classes happen on Google Meet. The join link activates on the day of the class."},
              ].map(item=>(
                <div key={item.role} style={{padding:"16px",background:"var(--s2)",borderRadius:12,border:"1px solid var(--b1)"}}>
                  <div style={{fontSize:22,marginBottom:8}}>{item.icon}</div>
                  <div style={{fontWeight:600,fontSize:13,color:"var(--t1)",marginBottom:5}}>{item.role}</div>
                  <div style={{fontSize:12.5,color:"var(--t2)",lineHeight:1.6}}>{item.desc}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="guide-sec">
            <div className="guide-sec-title">🔒 Access control</div>
            <div style={{display:"flex",flexDirection:"column",gap:7}}>
              {[
                {what:"Schedule / edit / delete classes",who:"Coordinator only"},
                {what:"View own classes & join via Meet",who:"Teacher & Student"},
                {what:"Chat with assigned people only",who:"Teacher & Student"},
                {what:"View files assigned to you",who:"Teacher & Student"},
                {what:"Support tickets",who:"All roles"},
                {what:"Full platform access",who:"Coordinator"},
              ].map(r=>(
                <div key={r.what} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 13px",background:"var(--s2)",borderRadius:8,border:"1px solid var(--b1)"}}>
                  <div style={{flex:1,fontSize:13,color:"var(--t1)"}}>{r.what}</div>
                  <span className={`bdg ${r.who==="Coordinator only"?"bdg-vi":r.who==="All roles"?"bdg-cy":"bdg-ac"}`}>{r.who}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {tab==="howto" && (user.role==="admin" ? adminGuide : user.role==="teacher" ? teacherGuide : user.role==="student" ? studentGuide : coordGuide)}
      {tab==="faqs" && (
        <div className="guide-sec">
          <div className="guide-sec-title">{IC.help} Frequently asked questions</div>
          {user.role==="teacher"&&<><FAQ id="tf1" q="I can't find the 'Schedule a class' button. Where is it?" a="Class scheduling is handled exclusively by your Coordinator. Use the Support tab to request a new class or reschedule." /><FAQ id="tf2" q="Why can I only see some students?" a="You only see students assigned to you by the Coordinator. Contact them to update assignments." /><FAQ id="tf3" q="The Join Meet button is greyed out." a="It activates on the day of the class. Refresh if it's not working then." /></>}
          {user.role==="student"&&<><FAQ id="sf1" q="How do I join a class?" a="Go to 'My Classes'. The green Join Meet button appears on the day of the class. Click it to open Google Meet in a new tab." /><FAQ id="sf2" q="I want to reschedule. What do I do?" a="Students can't reschedule directly. Raise a support ticket via 'Contact Coordinator' and explain the conflict." /><FAQ id="sf3" q="Why can't I see all teachers?" a="You only see teachers assigned to you. Contact your Coordinator if someone is missing." /></>}
          {user.role==="admin"&&<><FAQ id="adm1" q="Can I have more than one coordinator?" a="Yes — the platform supports multiple coordinators. Each coordinator has their own set of assigned teachers and students managed via Users Mapping." /><FAQ id="adm2" q="What happens if I delete a user?" a="Their Firebase Auth account and Firestore profile are permanently deleted. This cannot be undone. Reassign their students or teachers first if needed." /><FAQ id="adm3" q="How do I connect Google Calendar?" a="Go to Settings and click 'Connect Google Calendar'. This starts an OAuth2 flow. Once authorized, coordinators can create Google Meet links when scheduling classes." /></>}
          {user.role==="coordinator"&&<><FAQ id="cf1" q="How do I add a new student or teacher?" a="User creation is handled by the Admin. Contact your administrator to add new users to the platform." /><FAQ id="cf2" q="Can I assign the same student to multiple teachers?" a="Yes — each student has a teachers array in their profile. They can have one teacher per subject." /><FAQ id="cf3" q="How does recurring scheduling work?" a="When scheduling, check 'Repeat weekly' and choose 1–10. It creates separate class entries on the same weekday for consecutive weeks at the same time." /></>}
        </div>
      )}
    </div>
  );
}

// ─── TZ BAR ───────────────────────────────────────────────────────────────────
function TZBar({ user }) {
  const tz = user.tz || "Asia/Kolkata";
  const tzL = user.tzL || "IST";
  const [t, setT] = useState(nowTZ(tz));
  useEffect(()=>{ const iv=setInterval(()=>setT(nowTZ(tz)),30000); return()=>clearInterval(iv); },[tz]);
  return <div className="nb ok">{IC.globe} Your time ({tzL}): <strong>{t}</strong></div>;
}
// ─── CLASS RECORD (Admin) ─────────────────────────────────────────────────────
function ClassRecordPage({ allUsers, classes }) {
  const [filterCoord, setFilterCoord] = useState("all");
  const [filterTeacher, setFilterTeacher] = useState("all");
  const [filterMonth, setFilterMonth] = useState(() => {
    const now = new Date();
    return now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0");
  });

  const coordinators = allUsers.coordinators || [];
  const monthClasses = classes.filter(c => c.date && c.date.startsWith(filterMonth));

  const records = [];
  coordinators.forEach(coord => {
    if (filterCoord !== "all" && coord.id !== filterCoord) return;
    const coordTeachers = allUsers.teachers.filter(t => (coord.teachers || []).includes(t.id));
    coordTeachers.forEach(teacher => {
      if (filterTeacher !== "all" && teacher.id !== filterTeacher) return;
      const teacherClasses = monthClasses.filter(c => c.tId === teacher.id);
      const studentMap = {};
      teacherClasses.forEach(c => {
        (c.sIds || []).forEach(sId => {
          if (!studentMap[sId]) studentMap[sId] = { total: 0, done: 0, pending: 0 };
          studentMap[sId].total++;
          if (c.done) studentMap[sId].done++;
          else studentMap[sId].pending++;
        });
      });
      Object.keys(studentMap).forEach(sId => {
        const student = allUsers.students.find(s => s.id === sId);
        records.push({
          coordName: coord.name, coordId: coord.id,
          teacherName: teacher.name, teacherId: teacher.id, teacherSubject: teacher.subject,
          studentName: student?.name || "Unknown", studentId: sId, studentGrade: student?.grade || "",
          ...studentMap[sId]
        });
      });
    });
  });

  const monthOptions = [];
  const now = new Date();
  for (let i = 0; i < 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const val = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0");
    const label = d.toLocaleDateString("en-IN", { month: "long", year: "numeric" });
    monthOptions.push({ value: val, label });
  }

  const totalDone = records.reduce((s, r) => s + r.done, 0);
  const totalPending = records.reduce((s, r) => s + r.pending, 0);
  const totalAll = records.reduce((s, r) => s + r.total, 0);
  const filteredTeachersForDropdown = allUsers.teachers.filter(t =>
    filterCoord === "all" || (coordinators.find(c => c.id === filterCoord)?.teachers || []).includes(t.id)
  );

  return (
    <div className="vcol">
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "flex-end" }}>
        <div className="fld" style={{ marginBottom: 0 }}>
          <label style={{ fontSize: 10, fontWeight: 600, color: "var(--t3)" }}>Month</label>
          <select value={filterMonth} onChange={e => setFilterMonth(e.target.value)} style={{ padding: "6px 10px", background: "var(--s2)", border: "1px solid var(--b1)", borderRadius: 8, color: "var(--t1)", fontSize: 12 }}>
            {monthOptions.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
        </div>
        <div className="fld" style={{ marginBottom: 0 }}>
          <label style={{ fontSize: 10, fontWeight: 600, color: "var(--t3)" }}>Coordinator</label>
          <select value={filterCoord} onChange={e => { setFilterCoord(e.target.value); setFilterTeacher("all"); }} style={{ padding: "6px 10px", background: "var(--s2)", border: "1px solid var(--b1)", borderRadius: 8, color: "var(--t1)", fontSize: 12 }}>
            <option value="all">All Coordinators</option>
            {coordinators.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <div className="fld" style={{ marginBottom: 0 }}>
          <label style={{ fontSize: 10, fontWeight: 600, color: "var(--t3)" }}>Teacher</label>
          <select value={filterTeacher} onChange={e => setFilterTeacher(e.target.value)} style={{ padding: "6px 10px", background: "var(--s2)", border: "1px solid var(--b1)", borderRadius: 8, color: "var(--t1)", fontSize: 12 }}>
            <option value="all">All Teachers</option>
            {filteredTeachersForDropdown.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
        <div className="stile ac"><div className="st-lbl">Total Classes</div><div className="st-val">{totalAll}</div></div>
        <div className="stile em"><div className="st-lbl">Completed</div><div className="st-val">{totalDone}</div></div>
        <div className="stile wa"><div className="st-lbl">Pending</div><div className="st-val">{totalPending}</div></div>
      </div>

      <div className="card">
        <div className="card-title" style={{ marginBottom: 14 }}>{IC.cal} Class Records — {monthOptions.find(m => m.value === filterMonth)?.label}</div>
        {records.length === 0 && <div className="empty"><div className="empty-icon">📋</div>No class records found for this period</div>}
        {records.length > 0 && (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 80px 80px 80px", gap: 8, padding: "8px 12px", background: "var(--s3)", borderRadius: 8, marginBottom: 6, fontSize: 10, fontWeight: 700, color: "var(--t3)", textTransform: "uppercase", letterSpacing: ".5px" }}>
            <span>Coordinator</span><span>Teacher</span><span>Student</span>
            <span style={{textAlign:"center"}}>Total</span><span style={{textAlign:"center"}}>Done</span><span style={{textAlign:"center"}}>Pending</span>
          </div>
        )}
        {records.map((r, i) => (
          <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 80px 80px 80px", gap: 8, padding: "10px 12px", background: i % 2 === 0 ? "var(--s2)" : "transparent", borderRadius: 6, alignItems: "center", fontSize: 12 }}>
            <span style={{ color: "var(--t2)" }}>{r.coordName}</span>
            <span style={{ color: "var(--t1)", fontWeight: 500 }}>{r.teacherName}</span>
            <span style={{ color: "var(--t2)" }}>{r.studentName} <span style={{ fontSize: 10, color: "var(--t4)" }}>{r.studentGrade}</span></span>
            <span style={{ textAlign: "center", fontWeight: 600, color: "var(--t1)" }}>{r.total}</span>
            <span style={{ textAlign: "center", fontWeight: 600, color: "var(--em)" }}>{r.done}</span>
            <span style={{ textAlign: "center", fontWeight: 600, color: r.pending > 0 ? "var(--wa)" : "var(--t4)" }}>{r.pending}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── USER MANAGEMENT ──────────────────────────────────────────────────────────
function UserManagementPage({ user, allUsers, showToast }) {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [filter, setFilter] = useState("all");
  const [createdCreds, setCreatedCreds] = useState(null);
  const [cf, setCf] = useState({ name:"", email:"", role:"student", phone:"", subject:"", grade:"", location:"", country:"", tz:"Asia/Kolkata", tzL:"IST" });
  const [ef, setEf] = useState({});
  const [newPass, setNewPass] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const tzOptions = [
    { value:"Asia/Kolkata",      label:"India (IST)",              tzL:"IST"  },
    { value:"America/New_York",  label:"USA Eastern (ET)",         tzL:"ET"   },
    { value:"America/Chicago",   label:"USA Central (CT)",         tzL:"CT"   },
    { value:"America/Los_Angeles",label:"USA Pacific (PT)",        tzL:"PT"   },
    { value:"America/Toronto",   label:"Canada Eastern (ET)",      tzL:"ET"   },
    { value:"America/Vancouver", label:"Canada Pacific (PT)",      tzL:"PT"   },
    { value:"Australia/Perth",   label:"Australian Western Standard Time (AWST)", tzL:"AWST" },
    { value:"Australia/Darwin",  label:"Australian Central Standard Time (ACST)", tzL:"ACST" },
    { value:"Australia/Adelaide",label:"Australian Central Daylight Time (ACDT)", tzL:"ACDT" },
    { value:"Australia/Brisbane",label:"Australian Eastern Standard Time (AEST)", tzL:"AEST" },
    { value:"Australia/Sydney",  label:"Australian Eastern Daylight Time (AEDT)", tzL:"AEDT" },
    { value:"Pacific/Auckland",  label:"New Zealand (NZST)",       tzL:"NZST" },
    { value:"Asia/Dubai",        label:"UAE (GST)",                tzL:"GST"  },
    { value:"Europe/London",     label:"UK (GMT)",                 tzL:"GMT"  },
  ];

  const resetCreateForm = () => {
    setCf({ name:"", email:"", role:"student", phone:"", subject:"", grade:"", location:"", country:"", tz:"Asia/Kolkata", tzL:"IST" });
    setCreatedCreds(null);
  };

  const createNewUser = async () => {
    if (loading) return;
    
    // Mandatory field validation
    if (!cf.name || !cf.email || !cf.role || !cf.phone || !cf.location || !cf.country || !cf.tz) {
      showToast("Please fill all mandatory fields.");
      return;
    }
    
    if (!cf.phone.startsWith("+")) {
      showToast("Country code is required in phone number (e.g., +1, +91).");
      return;
    }

    const flatUsers = [
      ...(allUsers.admins || []),
      ...(allUsers.coordinators || []),
      ...(allUsers.coordinator ? [allUsers.coordinator] : []),
      ...(allUsers.teachers || []),
      ...(allUsers.students || [])
    ];

    const duplicate = flatUsers.find(u => u.email.toLowerCase() === cf.email.toLowerCase() || u.phone === cf.phone);
    if (duplicate) {
      showToast("User with the similar email or phone already exists in our system.");
      return;
    }

    if (cf.role === "teacher" && !cf.subject) {
      showToast("Please select at least one subject.");
      return;
    }
    if (cf.role === "student" && !cf.grade) {
      showToast("Please select a grade.");
      return;
    }

    try {
      setLoading(true);
      showToast("Creating user...");
      const token = await auth.currentUser.getIdToken();
      const response = await fetch("https://us-central1-vidvana-sphere.cloudfunctions.net/createUser", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
        body: JSON.stringify({ data: { email: cf.email, name: cf.name, role: cf.role, phone: cf.phone, subject: cf.subject, grade: cf.grade, location: cf.location, country: cf.country, tz: cf.tz, tzL: cf.tzL, initials: cf.name.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2) } }),
      });
      const resData = await response.json();
      if (resData.error) throw new Error(resData.error.message);
      const data = resData.result;
      setLoading(false);
      setCreatedCreds({ email: data.email, password: data.tempPassword, uid: data.uid });
      showToast("User created successfully!");
    } catch (err) {
      showToast("Error: " + (err.message || "Failed to create user"));
    } finally {
      setLoading(false);
    }
  };

  const openEdit = (u) => {
    setEditUser(u);
    setEf({ name:u.name||"", email:u.email||"", phone:u.phone||"", subject:u.subject||"", grade:u.grade||"", location:u.location||"", country:u.country||"", tz:u.tz||"Asia/Kolkata", tzL:u.tzL||"IST" });
    setShowEditModal(true);
  };

  const saveEdit = async () => {
    if (!editUser || loading) return;
    try {
      setLoading(true);
      showToast("Updating user...");
      const token = await auth.currentUser.getIdToken();
      const response = await fetch("https://us-central1-vidvana-sphere.cloudfunctions.net/updateUser", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
        body: JSON.stringify({ data: { uid: editUser.id, updates: ef } }),
      });
      const resData = await response.json();
      if (resData.error) throw new Error(resData.error.message);
      showToast("User updated!"); setShowEditModal(false); setEditUser(null);
    } catch (err) {
      showToast("Error: " + (err.message || "Failed to update"));
    } finally {
      setLoading(false);
    }
  };

  const changePassword = async () => {
    if (!editUser || !newPass || loading) return;
    if (newPass.length < 6) { showToast("Password must be at least 6 characters"); return; }
    try {
      setLoading(true);
      showToast("Updating password...");
      const token = await auth.currentUser.getIdToken();
      const response = await fetch("https://us-central1-vidvana-sphere.cloudfunctions.net/updateUser", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
        body: JSON.stringify({ data: { uid: editUser.id, updates: {}, newPassword: newPass } }),
      });
      const resData = await response.json();
      if (resData.error) throw new Error(resData.error.message);
      showToast("Password updated!"); setShowPasswordModal(false); setNewPass(""); setEditUser(null);
    } catch (err) {
      showToast("Error: " + (err.message || "Failed to update password"));
    } finally {
      setLoading(false);
    }
  };

  const deleteUserAccount = async (u) => {
    if (!window.confirm("Are you sure you want to delete " + u.name + " (" + u.email + ")?\n\nThis will permanently delete their account and all their data. This action cannot be undone.")) return;
    if (!window.confirm("FINAL CONFIRMATION: Delete " + u.name + "?\n\nClick OK to permanently delete this user.")) return;
    try {
      setLoading(true);
      const token = await auth.currentUser.getIdToken();
      const response = await fetch("https://us-central1-vidvana-sphere.cloudfunctions.net/deleteUser", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
        body: JSON.stringify({ data: { uid: u.id } }),
      });
      const resData = await response.json();
      if (resData.error) throw new Error(resData.error.message);
      showToast(u.name + " has been deleted");
    } catch (err) {
      showToast("Delete failed: " + (err.message || "Unknown error"));
    } finally {
      setLoading(false);
    }
  };

  const allUsersList = [
    ...(allUsers.admins || []),
    ...(allUsers.coordinators || []),
    ...(allUsers.teachers || []),
    ...(allUsers.students || []),
  ].sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  const filteredUsers = allUsersList.filter(u => {
    if (filter !== "all" && u.role !== filter) return false;
    if (filter === "all" && searchQuery && !u.name?.toLowerCase().includes(searchQuery.toLowerCase())) return false;
    return true;
  });

  return (
    <div className="vcol">
      {loading && (
        <div style={{ position:"fixed", top:0, left:0, right:0, bottom:0, background:"rgba(0,0,0,0.4)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:9999 }}>
          <div style={{ background:"var(--s1)", padding:"24px 40px", borderRadius:16, textAlign:"center", border:"1px solid var(--b1)" }}>
            <div style={{ fontSize:32, marginBottom:8 }}>⏳</div>
            <div style={{ fontSize:14, fontWeight:600, color:"var(--t1)" }}>Processing...</div>
            <div style={{ fontSize:12, color:"var(--t3)", marginTop:4 }}>Please wait</div>
          </div>
        </div>
      )}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10 }}>
        <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" }}>
          <button className={`btn ${filter==="all"?"btn-ac":"btn-gh"} btn-sm`} onClick={() => setFilter("all")}>All ({allUsersList.length})</button>
          <button className={`btn ${filter==="coordinator"?"btn-ac":"btn-gh"} btn-sm`} onClick={() => setFilter("coordinator")}>Coordinators</button>
          <button className={`btn ${filter==="teacher"?"btn-ac":"btn-gh"} btn-sm`} onClick={() => setFilter("teacher")}>Teachers</button>
          <button className={`btn ${filter==="student"?"btn-ac":"btn-gh"} btn-sm`} onClick={() => setFilter("student")}>Students</button>
          {filter === "all" && (
            <input 
              type="text" 
              placeholder="Search user by name..." 
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              style={{ padding:"6px 12px", borderRadius:6, border:"1px solid var(--b1)", background:"var(--s2)", color:"var(--t1)", fontSize:12, width:200, marginLeft: 8 }}
            />
          )}
        </div>
        <button className="btn btn-ac" onClick={() => { resetCreateForm(); setShowCreateModal(true); }}>{IC.plus} Create New User</button>
      </div>

      <div className="card">
        <div className="card-title" style={{ marginBottom:14 }}>{IC.people} All Users ({filteredUsers.length})</div>
        {filteredUsers.length === 0 && <div className="empty"><div className="empty-icon">👤</div>No users found</div>}
        {filteredUsers.map(u => (
          <div key={u.id} style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 14px", background:"var(--s2)", border:"1px solid var(--b1)", borderRadius:10, marginBottom:6 }}>
            <div className={`av ${u.role==="teacher"?"av-t":u.role==="student"?"av-s":"av-c"}`} style={{ width:38, height:38, fontSize:12 }}>{u.initials}</div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontSize:13, fontWeight:600, color:"var(--t1)" }}>{u.name}</div>
              <div style={{ fontSize:11, color:"var(--t3)" }}>
                {u.email} · {u.phone}
                {u.role==="teacher" && u.subject && <> · {u.subject}</>}
                {u.role==="student" && u.grade && <> · {u.grade}</>}
              </div>
            </div>
            <span className={`bdg ${u.role==="coordinator"?"bdg-vi":u.role==="teacher"?"bdg-ac":"bdg-em"}`}>{u.role}</span>
            <button className="btn btn-gh btn-sm" onClick={() => openEdit(u)}>{IC.edit}</button>
            <button className="btn btn-wa btn-sm" onClick={() => { setEditUser(u); setNewPass(""); setShowPasswordModal(true); }}>🔑</button>
            {u.id !== user.id && (
              <button className="btn btn-sm" style={{ background:"rgba(240,69,69,0.1)", color:"#f04545", border:"1px solid rgba(240,69,69,0.3)" }} onClick={() => deleteUserAccount(u)} title="Delete user">🗑</button>
            )}
          </div>
        ))}
      </div>

      {/* CREATE MODAL */}
      {showCreateModal && (
        <div className="ovl" onClick={e => e.target===e.currentTarget && !createdCreds && setShowCreateModal(false)}>
          <div className="mdl">
            {!createdCreds ? (
              <>
                <div className="mdl-title">{IC.plus} Create New User</div>
                <div className="fld"><label>Role *</label>
                  <select value={cf.role} onChange={e => setCf(f => ({...f, role:e.target.value}))}>
                    <option value="student">Student</option>
                    <option value="teacher">Teacher</option>
                    <option value="coordinator">Coordinator</option>
                  </select>
                </div>
                <div className="mgrid">
                  <div className="fld"><label>Full Name *</label><input value={cf.name} onChange={e => setCf(f => ({...f, name:e.target.value.toUpperCase()}))} placeholder="e.g. ARJUN MEHTA" /></div>
                  <div className="fld"><label>Email *</label><input type="email" value={cf.email} onChange={e => setCf(f => ({...f, email:e.target.value}))} placeholder="e.g. arjun@vidvana.in" /></div>
                </div>
                <div className="mgrid">
                  <div className="fld"><label>Phone *</label><input value={cf.phone} onChange={e => setCf(f => ({...f, phone:e.target.value.replace(/[^+\d\s-]/g, '')}))} placeholder="+91-98765-43210" /></div>
                  <div className="fld"><label>Location (City, State) *</label><input value={cf.location} onChange={e => setCf(f => ({...f, location:e.target.value.toUpperCase()}))} placeholder="MUMBAI, MAHARASHTRA" /></div>
                </div>
                <div className="mgrid">
                  <div className="fld"><label>Country *</label>
                    <select value={cf.country} onChange={e => setCf(f => ({...f, country:e.target.value}))}>
                      <option value="">Select Country</option>
                      {["USA", "Australia", "Canada", "NewZealand", "UAE", "India"].map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                  <div className="fld"><label>Timezone *</label>
                    <select value={cf.tz} onChange={e => { const s=tzOptions.find(t=>t.value===e.target.value); setCf(f=>({...f,tz:e.target.value,tzL:s?.tzL||"IST"})); }}>
                      <option value="">Select Timezone</option>
                      {tzOptions.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                    </select>
                  </div>
                </div>
                {cf.role==="teacher" && (
                  <div className="fld">
                    <label>Subjects *</label>
                    <div style={{ display:"flex",flexWrap:"wrap",gap:7,marginTop:6 }}>
                      {["English","Mathematics","Science","Arts","Chess","Public Speaking"].map(sub=>(
                        <label key={sub} style={{display:"flex",alignItems:"center",gap:7,cursor:"pointer",padding:"8px 11px",borderRadius:8,background:"var(--s2)",border:`1.5px solid ${cf.subject.includes(sub)?"var(--ac)":"var(--b1)"}`}}>
                          <input type="checkbox" checked={cf.subject.includes(sub)} onChange={(e)=>{
                            const curr = cf.subject ? cf.subject.split(', ').filter(Boolean) : [];
                            if(e.target.checked) curr.push(sub);
                            else curr.splice(curr.indexOf(sub), 1);
                            setCf(f => ({...f, subject: curr.join(', ')}))
                          }} />
                          <span style={{fontSize:12.5}}>{sub}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                )}
                {cf.role==="student" && (
                  <div className="fld">
                    <label>Grade/Class *</label>
                    <select value={cf.grade} onChange={e => setCf(f => ({...f, grade:e.target.value}))}>
                      <option value="">Select Grade</option>
                      {Array.from({length:12}, (_,i)=>"Grade "+(i+1)).map(g=><option key={g} value={g}>{g}</option>)}
                    </select>
                  </div>
                )}
                <p style={{ fontSize:11, color:"var(--t3)", marginBottom:12 }}>A temporary password will be auto-generated. You can share it with the user.</p>
                <div className="dp" style={{ justifyContent:"flex-end", gap:8 }}>
                  <button className="btn btn-gh" onClick={() => setShowCreateModal(false)}>Cancel</button>
                  <button className="btn btn-ac" onClick={createNewUser} disabled={loading} style={loading ? { opacity:0.6, cursor:"not-allowed" } : {}}>{loading ? "⏳ Creating..." : <>{IC.plus} Create User</>}</button>
                </div>
              </>
            ) : (
              <>
                <div className="mdl-title" style={{ color:"var(--em)" }}>{IC.check} User Created Successfully!</div>
                <div style={{ padding:16, background:"var(--em2)", border:"1px solid var(--em)", borderRadius:10, marginBottom:16 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                    <div style={{ fontSize:13, fontWeight:600, color:"var(--t1)" }}>Login Credentials (share with user):</div>
                    <button className="btn btn-gh btn-sm" style={{ padding: "4px 8px", fontSize: 11 }} onClick={() => { navigator.clipboard.writeText(`Email: ${createdCreds.email}\nPassword: ${createdCreds.password}`); showToast("Copied to clipboard!"); }}>📋 Copy</button>
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6 }}>
                    <span style={{ fontSize:12, color:"var(--t3)", width:70 }}>Email:</span>
                    <span style={{ fontSize:13, fontWeight:600, color:"var(--t1)" }}>{createdCreds.email}</span>
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6 }}>
                    <span style={{ fontSize:12, color:"var(--t3)", width:70 }}>Password:</span>
                    <span style={{ fontSize:13, fontWeight:600, color:"var(--ac)", fontFamily:"monospace" }}>{createdCreds.password}</span>
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <span style={{ fontSize:12, color:"var(--t3)", width:70 }}>UID:</span>
                    <span style={{ fontSize:11, color:"var(--t4)", fontFamily:"monospace" }}>{createdCreds.uid}</span>
                  </div>
                </div>
                <p style={{ fontSize:11, color:"var(--wa)", marginBottom:12 }}>⚠️ Save these credentials. The temporary password cannot be retrieved later.</p>
                <button className="btn btn-ac" style={{ width:"100%", justifyContent:"center" }} onClick={() => { setShowCreateModal(false); resetCreateForm(); window.location.reload(); }}>Done</button>
              </>
            )}
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {showEditModal && editUser && (
        <div className="ovl" onClick={e => e.target===e.currentTarget && setShowEditModal(false)}>
          <div className="mdl">
            <div className="mdl-title">{IC.edit} Edit User — {editUser.name}</div>
            <div className="mgrid">
              <div className="fld"><label>Full Name *</label><input value={ef.name} onChange={e => setEf(f=>({...f,name:e.target.value}))} /></div>
              <div className="fld"><label>Email *</label><input value={ef.email} onChange={e => setEf(f=>({...f,email:e.target.value}))} /></div>
            </div>
            <div className="mgrid">
              <div className="fld"><label>Phone *</label><input value={ef.phone} onChange={e => setEf(f=>({...f,phone:e.target.value}))} /></div>
              <div className="fld"><label>Location (City, State) *</label><input value={ef.location} onChange={e => setEf(f=>({...f,location:e.target.value}))} /></div>
            </div>
            <div className="mgrid">
              <div className="fld"><label>Country *</label>
                <select value={ef.country} onChange={e => setEf(f => ({...f, country:e.target.value}))}>
                  <option value="">Select Country</option>
                  {["USA", "Australia", "Canada", "NewZealand", "UAE", "India"].map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div className="fld"><label>Timezone *</label>
                <select value={ef.tz} onChange={e => { const s=tzOptions.find(t=>t.value===e.target.value); setEf(f=>({...f,tz:e.target.value,tzL:s?.tzL||"IST"})); }}>
                  <option value="">Select Timezone</option>
                  {tzOptions.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
              </div>
            </div>
            {editUser.role==="teacher" && (
              <div className="fld">
                <label>Subjects *</label>
                <div style={{ display:"flex",flexWrap:"wrap",gap:7,marginTop:6 }}>
                  {["English","Mathematics","Science","Arts","Chess","Public Speaking"].map(sub=>(
                    <label key={sub} style={{display:"flex",alignItems:"center",gap:7,cursor:"pointer",padding:"8px 11px",borderRadius:8,background:"var(--s2)",border:`1.5px solid ${ef.subject?.includes(sub)?"var(--ac)":"var(--b1)"}`}}>
                      <input type="checkbox" checked={ef.subject?.includes(sub) || false} onChange={(e)=>{
                        const curr = ef.subject ? ef.subject.split(', ').filter(Boolean) : [];
                        if(e.target.checked) curr.push(sub);
                        else curr.splice(curr.indexOf(sub), 1);
                        setEf(f => ({...f, subject: curr.join(', ')}))
                      }} />
                      <span style={{fontSize:12.5}}>{sub}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            {editUser.role==="student" && (
              <div className="fld">
                <label>Grade/Class *</label>
                <select value={ef.grade} onChange={e => setEf(f => ({...f, grade:e.target.value}))}>
                  <option value="">Select Grade</option>
                  {Array.from({length:12}, (_,i)=>"Grade "+(i+1)).map(g=><option key={g} value={g}>{g}</option>)}
                </select>
              </div>
            )}
            <div className="dp" style={{ justifyContent:"flex-end", gap:8, marginTop:8 }}>
              <button className="btn btn-gh" onClick={() => setShowEditModal(false)}>Cancel</button>
              <button className="btn btn-ac" onClick={saveEdit} disabled={loading} style={loading ? { opacity:0.6, cursor:"not-allowed" } : {}}>{loading ? "⏳ Saving..." : <>{IC.check} Save Changes</>}</button>
            </div>
          </div>
        </div>
      )}

      {/* CHANGE PASSWORD MODAL */}
      {showPasswordModal && editUser && (
        <div className="ovl" onClick={e => e.target===e.currentTarget && setShowPasswordModal(false)}>
          <div className="mdl">
            <div className="mdl-title">🔑 Change Password — {editUser.name}</div>
            <p style={{ fontSize:12, color:"var(--t2)", marginBottom:14 }}>Set a new password for {editUser.email}</p>
            <div className="fld"><label>Current Password</label><input type="text" value={editUser.pass || "Hidden/Unknown"} disabled style={{ background: "var(--s2)", color: "var(--t3)", cursor: "not-allowed" }} /></div>
            <div className="fld"><label>New Password</label><input type="text" value={newPass} onChange={e => setNewPass(e.target.value)} placeholder="Minimum 6 characters" /></div>
            <div className="dp" style={{ justifyContent:"flex-end", gap:8 }}>
              <button className="btn btn-gh" onClick={() => setShowPasswordModal(false)}>Cancel</button>
              <button className="btn btn-ac" onClick={changePassword} disabled={loading} style={loading ? { opacity:0.6, cursor:"not-allowed" } : {}}>{loading ? "⏳ Updating..." : "🔑 Update Password"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── USERS MAPPING PAGE ───────────────────────────────────────────────────────
function UsersMappingPage({ user, allUsers, showToast }) {
  const [selCoord, setSelCoord] = useState(null);
  const [selTeacher, setSelTeacher] = useState(null);
  const [editingTeachers, setEditingTeachers] = useState(false);
  const [editingStudents, setEditingStudents] = useState(false);
  const [selTeacherIds, setSelTeacherIds] = useState([]);
  const [selStudentIds, setSelStudentIds] = useState([]);
  const [studentSearch, setStudentSearch] = useState("");

  const uniqueCoords = allUsers.coordinators || (allUsers.coordinator ? [allUsers.coordinator] : []);
  const currentCoord = selCoord ? uniqueCoords.find(c => c.id === selCoord.id) || selCoord : null;
  const currentTeacher = selTeacher ? allUsers.teachers.find(t => t.id === selTeacher.id) || selTeacher : null;

  useEffect(() => {
    if (selCoord) {
      setSelTeacherIds(selCoord.teachers || []);
      setSelTeacher(null);
      setSelStudentIds([]);
      setEditingTeachers(false);
      setEditingStudents(false);
    }
  }, [selCoord?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (selTeacher && selCoord) {
      const byCoord = selTeacher.studentsByCoord || {};
      if (byCoord[selCoord.id] !== undefined) {
        setSelStudentIds(byCoord[selCoord.id]);
      } else {
        setSelStudentIds(selTeacher.coordinatorId === selCoord.id ? (selTeacher.students || []) : []);
      }
      setEditingStudents(false);
      setStudentSearch("");
    }
  }, [selTeacher?.id, selCoord?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const saveTeacherAssignments = async () => {
    if (!selCoord) return;
    try {
      await updateDoc(doc(db, "users", selCoord.id), { teachers: selTeacherIds });
      for (const t of allUsers.teachers) {
        if (selTeacherIds.includes(t.id)) {
          await updateDoc(doc(db, "users", t.id), { coordinatorId: selCoord.id });
        } else if (t.coordinatorId === selCoord.id) {
          await updateDoc(doc(db, "users", t.id), { coordinatorId: "" });
        }
      }
      showToast("Teacher assignments saved!");
      setEditingTeachers(false);
    } catch (err) { showToast("Error: " + err.message); }
  };

  const saveStudentAssignments = async () => {
    if (!selTeacher || !selCoord) return;
    try {
      const byCoord = selTeacher.studentsByCoord || {};
      const newByCoord = { ...byCoord, [selCoord.id]: selStudentIds };
      
      const allStudentIdsSet = new Set();
      Object.values(newByCoord).forEach(arr => arr.forEach(id => allStudentIdsSet.add(id)));
      const allStudentIds = Array.from(allStudentIdsSet);

      await updateDoc(doc(db, "users", selTeacher.id), { 
        students: allStudentIds,
        studentsByCoord: newByCoord
      });
      for (const s of allUsers.students) {
        const st = s.teachers || [];
        const isAssigned = allStudentIds.includes(s.id);
        const wasAssigned = st.includes(selTeacher.id);
        if (isAssigned && !wasAssigned) {
          await updateDoc(doc(db, "users", s.id), { teachers: [...st, selTeacher.id] });
        } else if (!isAssigned && wasAssigned) {
          await updateDoc(doc(db, "users", s.id), { teachers: st.filter(id => id !== selTeacher.id) });
        }
      }
      showToast("Student assignments saved!");
      setEditingStudents(false);
    } catch (err) { showToast("Error: " + err.message); }
  };

  const coordTeachers = currentCoord ? allUsers.teachers.filter(t => (currentCoord.teachers || []).includes(t.id)) : [];

  return (
    <div className="vcol">
      {/* Step 1 */}
      <div className="card">
        <div className="card-title" style={{ marginBottom:14 }}>{IC.people} Step 1 — Select Coordinator</div>
        <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
          {uniqueCoords.length === 0 && <div className="empty"><div className="empty-icon">👤</div>No coordinators found. Create one from Manage Users.</div>}
          {uniqueCoords.map(c => (
            <div key={c.id} onClick={() => setSelCoord(c)}
              style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 16px",
                background: selCoord?.id===c.id ? "var(--vi2)" : "var(--s2)",
                border:"1.5px solid "+(selCoord?.id===c.id ? "var(--vi)" : "var(--b1)"),
                borderRadius:10, cursor:"pointer" }}>
              <div className="av av-c" style={{ width:32,height:32,fontSize:10 }}>{c.initials}</div>
              <div>
                <div style={{ fontSize:13,fontWeight:600,color:"var(--t1)" }}>{c.name}</div>
                <div style={{ fontSize:11,color:"var(--t3)" }}>{(c.teachers||[]).length} teachers assigned</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Step 2 */}
      {currentCoord && (
        <div className="card">
          <div className="card-hd">
            <div className="card-title">{IC.people} Step 2 — Teachers under {currentCoord.name}</div>
            <div style={{ display:"flex", gap:8 }}>
              {!editingTeachers ? (
                <button className="btn btn-ac btn-sm" onClick={() => setEditingTeachers(true)}>{IC.edit} Edit</button>
              ) : (
                <>
                  <button className="btn btn-gh btn-sm" onClick={() => { setEditingTeachers(false); setSelTeacherIds(currentCoord.teachers||[]); }}>Cancel</button>
                  <button className="btn btn-ac btn-sm" onClick={saveTeacherAssignments}>{IC.check} Save</button>
                </>
              )}
            </div>
          </div>
          {editingTeachers ? (
            <div style={{ display:"flex",flexDirection:"column",gap:6 }}>
              {allUsers.teachers.map(t => (
                <label key={t.id} style={{ display:"flex",alignItems:"center",gap:12,padding:"10px 14px",
                  background: selTeacherIds.includes(t.id) ? "var(--ac3)" : "var(--s2)",
                  border:"1.5px solid "+(selTeacherIds.includes(t.id) ? "var(--ac)" : "var(--b1)"),
                  borderRadius:10, cursor:"pointer" }}>
                  <input type="checkbox" checked={selTeacherIds.includes(t.id)}
                    onChange={() => setSelTeacherIds(p => p.includes(t.id) ? p.filter(id=>id!==t.id) : [...p,t.id])} />
                  <div className="av av-t" style={{ width:30,height:30,fontSize:10 }}>{t.initials}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:13,fontWeight:500,color:"var(--t1)" }}>{t.name}</div>
                    <div style={{ fontSize:11,color:"var(--t3)" }}>{t.email} · {t.subject}</div>
                  </div>
                </label>
              ))}
            </div>
          ) : (
            <div style={{ display:"flex",flexDirection:"column",gap:6 }}>
              {coordTeachers.length===0 && <div className="empty"><div className="empty-icon">👤</div>No teachers assigned. Click "Edit" to assign.</div>}
              {coordTeachers.map(t => (
                <div key={t.id} onClick={() => setSelTeacher(t)}
                  style={{ display:"flex",alignItems:"center",gap:12,padding:"10px 14px",
                    background: selTeacher?.id===t.id ? "var(--ac3)" : "var(--s2)",
                    border:"1.5px solid "+(selTeacher?.id===t.id ? "var(--ac)" : "var(--b1)"),
                    borderRadius:10, cursor:"pointer" }}>
                  <div className="av av-t" style={{ width:30,height:30,fontSize:10 }}>{t.initials}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:13,fontWeight:600,color:"var(--t1)" }}>{t.name}</div>
                    <div style={{ fontSize:11,color:"var(--t3)" }}>{t.subject} · {(t.studentsByCoord?.[currentCoord.id] || []).length} students</div>
                  </div>
                  <span className="bdg bdg-ac">{(t.studentsByCoord?.[currentCoord.id] || []).length} students</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Step 3 */}
      {currentTeacher && !editingTeachers && (
        <div className="card">
          <div className="card-hd">
            <div className="card-title">{IC.people} Step 3 — Students under {currentTeacher.name}</div>
            <div style={{ display:"flex", gap:8 }}>
              {!editingStudents ? (
                <button className="btn btn-ac btn-sm" onClick={() => setEditingStudents(true)}>{IC.edit} Edit</button>
              ) : (
                <>
                  <button className="btn btn-gh btn-sm" onClick={() => { setEditingStudents(false); setSelStudentIds(currentTeacher.students||[]); }}>Cancel</button>
                  <button className="btn btn-ac btn-sm" onClick={saveStudentAssignments}>{IC.check} Save</button>
                </>
              )}
            </div>
          </div>
          {editingStudents ? (
            <div style={{ display:"flex",flexDirection:"column",gap:6 }}>
              <input type="text" placeholder="Search students..." value={studentSearch} onChange={e => setStudentSearch(e.target.value)} style={{ padding:"8px", borderRadius:"6px", border:"1px solid var(--b1)", marginBottom:"8px", width: "33%" }} />
              <div style={{ display:"flex",flexDirection:"column",gap:6, maxHeight: "300px", overflowY: "auto", paddingRight: "4px" }}>
                {allUsers.students.filter(s => s.name.toLowerCase().includes(studentSearch.toLowerCase())).map(s => (
                  <label key={s.id} style={{ display:"flex",alignItems:"center",gap:12,padding:"10px 14px",
                    background: selStudentIds.includes(s.id) ? "var(--em2)" : "var(--s2)",
                    border:"1.5px solid "+(selStudentIds.includes(s.id) ? "var(--em)" : "var(--b1)"),
                    borderRadius:10, cursor:"pointer" }}>
                    <input type="checkbox" checked={selStudentIds.includes(s.id)}
                      onChange={() => setSelStudentIds(p => p.includes(s.id) ? p.filter(id=>id!==s.id) : [...p,s.id])} />
                    <div className="av av-s" style={{ width:30,height:30,fontSize:10 }}>{s.initials}</div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:13,fontWeight:500,color:"var(--t1)" }}>{s.name}</div>
                      <div style={{ fontSize:11,color:"var(--t3)" }}>{s.email} · {s.grade}</div>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          ) : (
            <div style={{ display:"flex",flexDirection:"column",gap:6 }}>
              {selStudentIds.length===0 && <div className="empty"><div className="empty-icon">👤</div>No students assigned. Click "Edit" to assign.</div>}
              {selStudentIds.length > 0 && (
                <>
                  <input type="text" placeholder="Search students..." value={studentSearch} onChange={e => setStudentSearch(e.target.value)} style={{ padding:"8px", borderRadius:"6px", border:"1px solid var(--b1)", marginBottom:"8px", width: "33%" }} />
                  <div style={{ display:"flex",flexDirection:"column",gap:6, maxHeight: "300px", overflowY: "auto", paddingRight: "4px" }}>
                    {allUsers.students.filter(s=>(selStudentIds||[]).includes(s.id) && s.name.toLowerCase().includes(studentSearch.toLowerCase())).map(s => (
                      <div key={s.id} style={{ display:"flex",alignItems:"center",gap:12,padding:"10px 14px",
                        background:"var(--s2)",border:"1px solid var(--b1)",borderRadius:10 }}>
                        <div className="av av-s" style={{ width:30,height:30,fontSize:10 }}>{s.initials}</div>
                        <div style={{ flex:1 }}>
                          <div style={{ fontSize:13,fontWeight:600,color:"var(--t1)" }}>{s.name}</div>
                          <div style={{ fontSize:11,color:"var(--t3)" }}>{s.email} · {s.grade}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}

      {/* Full Hierarchy Overview */}
      <div className="card">
        <div className="card-title" style={{ marginBottom:14 }}>{IC.people} Complete Hierarchy Overview</div>
        {uniqueCoords.length===0 && <div className="empty"><div className="empty-icon">🏢</div>No coordinators yet.</div>}
        {uniqueCoords.map(c => {
          const cTeachers = allUsers.teachers.filter(t => (c.teachers||[]).includes(t.id));
          return (
            <div key={c.id} style={{ marginBottom:16,padding:14,background:"var(--s2)",border:"1px solid var(--b1)",borderRadius:12 }}>
              <div style={{ display:"flex",alignItems:"center",gap:10,marginBottom:10 }}>
                <div className="av av-c" style={{ width:34,height:34,fontSize:11 }}>{c.initials}</div>
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:700,fontSize:14,color:"var(--t1)" }}>{c.name}</div>
                  <div style={{ fontSize:11,color:"var(--t3)" }}>Coordinator · {cTeachers.length} teachers</div>
                </div>
                <span className="bdg bdg-vi">Coordinator</span>
              </div>
              {cTeachers.length===0 && <div style={{ fontSize:12,color:"var(--t4)",paddingLeft:44 }}>No teachers assigned</div>}
              {cTeachers.map(t => {
                const tStudents = allUsers.students.filter(s => (t.studentsByCoord?.[c.id] || []).includes(s.id));
                return (
                  <div key={t.id} style={{ marginLeft:30,marginBottom:8,padding:"10px 12px",background:"var(--s3)",borderRadius:8,borderLeft:"3px solid var(--ac)" }}>
                    <div style={{ display:"flex",alignItems:"center",gap:8,marginBottom:6 }}>
                      <div className="av av-t" style={{ width:26,height:26,fontSize:9 }}>{t.initials}</div>
                      <div style={{ flex:1 }}>
                        <span style={{ fontSize:13,fontWeight:600,color:"var(--t1)" }}>{t.name}</span>
                        <span style={{ fontSize:11,color:"var(--t3)" }}> · {t.subject}</span>
                      </div>
                      <span className="bdg bdg-ac" style={{ fontSize:10 }}>{tStudents.length} students</span>
                    </div>
                    <div style={{ display:"flex",flexWrap:"wrap",gap:4,paddingLeft:34 }}>
                      {tStudents.length===0 && <span style={{ fontSize:11,color:"var(--t4)" }}>No students</span>}
                      {tStudents.map(s => (
                        <span key={s.id} style={{ display:"inline-flex",alignItems:"center",gap:4,padding:"3px 8px",background:"var(--s2)",borderRadius:12,fontSize:11,color:"var(--t2)",border:"1px solid var(--b1)" }}>
                          <div className="av av-s" style={{ width:16,height:16,fontSize:7 }}>{s.initials}</div>
                          {s.name}
                        </span>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── ROOT ─────────────────────────────────────────────────────────────────────
export default function App() {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [pg, setPg] = useState(() => sessionStorage.getItem("vidvana_activePage") || "dashboard");
  const [dk, setDk] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const iv = setInterval(() => setTick(t => t + 1), 60000);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    sessionStorage.setItem("vidvana_activePage", pg);
  }, [pg]);
  const [classes, setClasses] = useState([]);
  const [allUsers, setAllUsers] = useState({ students: [], teachers: [], coordinators: [], coordinator: null, admins: [] });
  const [files, setFiles] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [toast, setToast] = useState(null);
  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(null),3200); };
  const toggle = () => setDk(d=>!d);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const userDoc = await getDoc(doc(db, "users", firebaseUser.uid));
        if (userDoc.exists()) {
          setUser({ id: firebaseUser.uid, ...normalizeDoc(userDoc.data()) });
        }
      } else {
        setUser(null);
      }
      setAuthChecked(true);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!user?.id) return;
    const unsub = onSnapshot(doc(db, "users", user.id), (snap) => {
      if (snap.exists()) setUser(prev => ({ ...prev, ...normalizeDoc(snap.data()) }));
    });
    return () => unsub();
  }, [user?.id]);

  useEffect(() => {
    if (!user) return;
    const unsub = onSnapshot(collection(db, "users"), (snap) => {
      const students = [], teachers = [], coordinators = [], admins = [];
      snap.docs.forEach(d => {
        const data = { id: d.id, ...normalizeDoc(d.data()) };
        if (data.role === "student") students.push(data);
        else if (data.role === "teacher") teachers.push(data);
        else if (data.role === "coordinator") coordinators.push(data);
        else if (data.role === "admin") admins.push(data);
      });
      setAllUsers({ students, teachers, coordinators, coordinator: coordinators[0] || null, admins });
    });
    return () => unsub();
  }, [user]);

  useEffect(() => {
    if (!user) return;
    const unsub = onSnapshot(collection(db, "classes"), (snap) => {
      setClasses(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, [user]);

  useEffect(() => {
    if (!user) return;
    const unsub = onSnapshot(collection(db, "files"), (snap) => {
      setFiles(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, [user]);

  useEffect(() => {
    if (!user) return;
    const unsub = onSnapshot(collection(db, "tickets"), (snap) => {
      setTickets(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, [user]);



  const myUsers = useMemo(() => {
    if (!user || user.role !== "coordinator") return allUsers;
    const myTeacherIds = user.teachers || [];
    const myTeachers = allUsers.teachers.filter(t => myTeacherIds.includes(t.id));
    const myStudentIds = myTeachers.flatMap(t => t.students || []);
    const myStudents = allUsers.students.filter(s => myStudentIds.includes(s.id));
    return { ...allUsers, teachers: myTeachers, students: myStudents };
  }, [user, allUsers]);

  const TITLES = {
    dashboard:"Dashboard",schedule:"Manage Schedule",myclasses:"My Classes",
    assignments:"Assign Students to Teachers",
    usermgmt:"Manage Users",
    usermapping:"Users Mapping",
    classrecord:"Class Record",
    students:"All Students",mystudents:"My Students",teachers:"All Teachers",myteachers:"My Teachers",
    chat:"Messages",files:"Files & Materials",attendance:"Attendance",
    support:user?.role==="coordinator"?"Support Tickets":"Help Desk",
    guidelines:"Guidelines & Help",
  };

  const render = () => {
    if (!user) return null;
    if (pg==="dashboard")   return <Dashboard user={user} classes={classes} setPage={setPg} allUsers={user.role==="admin" ? allUsers : myUsers}/>;
    if (pg==="schedule")    return user.role==="coordinator" ? <SchedulePage classes={classes} showToast={showToast} allUsers={myUsers} user={user}/> : <div className="empty"><div className="empty-icon">🔒</div>Only Coordinators can manage the schedule.</div>;
    if (pg==="myclasses")   return <MyClasses user={user} classes={classes} showToast={showToast} allUsers={myUsers}/>;
    if (pg==="usermgmt") return user.role==="admin" ? <UserManagementPage user={user} allUsers={allUsers} showToast={showToast} /> : null;
    if (pg==="usermapping") return user.role==="admin" ? <UsersMappingPage user={user} allUsers={allUsers} showToast={showToast} /> : null;
    if (pg==="classrecord") return user.role==="admin" ? <ClassRecordPage allUsers={allUsers} classes={classes} /> : null;
    if (pg==="students"||pg==="mystudents") return <PeoplePage user={user} which="students" allUsers={myUsers}/>;
    if (pg==="teachers"||pg==="myteachers") return <PeoplePage user={user} which="teachers" allUsers={myUsers}/>;
    if (pg==="chat")        return <ChatPage user={user} allUsers={myUsers}/>;
    if (pg==="files")       return <FilesPage user={user} files={files} showToast={showToast} allUsers={myUsers}/>;
    if (pg==="attendance")  return <AttendancePage user={user} classes={classes} showToast={showToast} allUsers={myUsers}/>;
    if (pg==="support")     return <SupportPage user={user} tickets={tickets} showToast={showToast} allUsers={myUsers}/>;
    if (pg==="guidelines")  return <GuidelinesPage user={user}/>;
    return null;
  };

  const tzInfo = user?.tz ? `${user.tzL} · ${nowTZ(user.tz)}` : null;

  // Apply theme class to document root
  useEffect(() => {
    document.documentElement.className = dk ? '' : 'light';
  }, [dk]);

  return (
    <>
      {!authChecked ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'var(--bg)', color: 'var(--t1)' }}>Loading...</div>
      ) : !user ? (
        <LoginPage onLogin={u=>{setUser(u);setPg("dashboard");}} dk={dk} toggle={toggle}/>
      ) : (
        <div className="app">
          <Sidebar user={user} page={pg} setPage={setPg} onLogout={async ()=>{ await signOut(auth); setUser(null);setPg("dashboard");}} dk={dk} toggle={toggle}/>
          <div className="main">
            <TZBar user={user}/>
            <div className="topbar">
              <div style={{display:"flex",alignItems:"center",gap:10}}>
              <img src={LOGO_B64} alt="" style={{width:34,height:28,objectFit:"contain"}} />
              <div className="tb-title">{TITLES[pg]||"—"}</div>
            </div>
              <div className="tb-right">
                {tzInfo && <span className="tz-chip">{IC.globe} {tzInfo}</span>}
                <span style={{fontSize:11.5,color:"var(--t3)",fontWeight:500}}>{user.name}</span>
              </div>
            </div>
            <div className="pg">{render()}</div>
          </div>
        </div>
      )}
      {toast && (
        <div className="toast">
          <span style={{color:"var(--em)"}}>{IC.check}</span> {toast}
        </div>
      )}
    </>
  );
}